/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AbsenceModel,
  AbsenceModelPaginatedResponse,
  AbsenceReportRequest,
  AbsenceServiceModuleModel,
  ActionModuleCompletionResult,
  ActionModuleEmployeeResponsePaginatedResponse,
  ActionModuleIncentivationPageFiltersResponse,
  ActionModuleInstanceIncentivationRequest,
  ActionModuleInstanceModel,
  ActionModuleResponse,
  ActivatedAccountsReportingResponse,
  AveragePointsReportingResponse,
  AveragePresenceQuotaReportingResponse,
  AverageStarsAndResponseRateResponse,
  BaseAuditLogModelPaginatedResponse,
  BaseShopModuleModel,
  BinaryRewardCalculationInformation,
  CalendarEventSurveyAnswer,
  CalendarServiceModuleAbsenceEventModel,
  CalendarServiceModuleAnniversaryEventModel,
  CalendarServiceModuleBirthdayEventModel,
  CalendarServiceModuleEventModel,
  CalendarServiceModuleModel,
  ChecklistAnswerStreakResponse,
  CompanyAnalysisFileResponsePaginatedResponse,
  CompanyAssignedStoreEntryModel,
  CompanyCustomizationsResponse,
  CompanyInvoiceFileResponsePaginatedResponse,
  CompanyPensionShopModuleModel,
  CompanyResponse,
  CompleteInstanceValidationResultModel,
  ControlSignatureStatisticsMonthlyResponse,
  ControlSignatureStatisticsWeeklyResponse,
  CreateActionModuleRequest,
  CreateCalendarServiceModuleEventModel,
  CreateCompanyManagementUserModel,
  CreateEmployeeRequest,
  CreateGroupRequest,
  CreateProjectRequest,
  CreateServiceModuleModel,
  CreateStatusLevelModel,
  CreateSubCompanyModel,
  CreateTimeQuotaRequest,
  CreateVacationQuotaRequest,
  CreateWalletTypeRequest,
  DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams,
  DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams,
  DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams,
  DirectPayoutShopModuleModel,
  DocumentManagementRequestBase,
  DoneActionModulesReportingResponse,
  EmployeePageFiltersResponse,
  EmployeeServiceModuleEmployeeReadStateResponsePaginatedResponse,
  EmployeeUserAccountRequest,
  EmployeeUserAccountResponse,
  EmployeeUserDetailedResponse,
  EmployeeUserResponse,
  EmployeeUserResponsePaginatedResponse,
  EmployeeUserResponsePaginatedResponseWithIds,
  ErrorResponse,
  EvaluationThumbsStatisticsResponse,
  ExtendedGroupResponsePaginatedResponse,
  FileServiceModuleModel,
  FinishVacationQuotaRequest,
  FolderServiceModuleModel,
  FullPayoutBatchModelPaginatedResponse,
  FullPayoutShopModuleModel,
  FullPayoutShopModuleOverviewModel,
  GenericInAppNotificationDefinitionDetailResponse,
  GenericInAppNotificationDefinitionRequest,
  GenericInAppNotificationDefinitionResponse,
  GenericInAppNotificationDefinitionResponsePaginatedResponse,
  GetApiCompaniesCurrentAccountmanagementEmployeesParams,
  GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams,
  GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams,
  GetApiCompaniesCurrentActionmodulesFilteredParams,
  GetApiCompaniesCurrentAnalysisfilesParams,
  GetApiCompaniesCurrentAuditlogsParams,
  GetApiCompaniesCurrentDocumentmanagementParams,
  GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams,
  GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams,
  GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams,
  GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams,
  GetApiCompaniesCurrentEmployeesReportingTotalpointsParams,
  GetApiCompaniesCurrentInvoicesParams,
  GetApiCompaniesCurrentNotificationsParams,
  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams,
  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams,
  GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams,
  GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams,
  GetApiCompaniesCurrentServicemodulesFilteredParams,
  GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams,
  GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams,
  GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams,
  GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams,
  GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams,
  GetApiCompaniesCurrentShopmodulesFilteredParams,
  GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams,
  GetApiCompaniesCurrentTaxbenefitgroupsParams,
  GetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty200One,
  GetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty200Two,
  GetPayoutsParams,
  GroupResponse,
  GroupsPageFiltersResponse,
  HealthInsuranceEmployeeConfigModel,
  ImportActionModuleScoresRequest,
  InsuranceServiceModuleModel,
  LatestPersonalDocumentResponse,
  LeaderboardServiceModuleModel,
  LeaderboardUserRankModel,
  LeaderboardUserRankModelPaginatedResponse,
  LocalizationEntityType,
  LoginSuccessfulResponse,
  ManualInputRewardCalculationInformation,
  PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody,
  PatchApiCompaniesCurrentActionmodulesActionModuleIdParams,
  PatchApiCompaniesCurrentCustomizationsLogoBody,
  PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,
  PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody,
  PatchApiCompaniesCurrentServicemodulesIdIconBody,
  PatchApiCompaniesCurrentServicemodulesParentParams,
  PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams,
  PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne,
  PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree,
  PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo,
  PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams,
  PensionInsuranceEmployeeConfigModel,
  PersonalDocumentEmployeeResponse,
  PersonalDocumentResponse,
  PersonalDocumentsServiceModuleModel,
  PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams,
  PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams,
  PostApiCompaniesCurrentActionmodulesParams,
  PostApiCompaniesCurrentNotificationsIdImageBody,
  PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams,
  PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,
  PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody,
  PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody,
  PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody,
  ProblemDetails,
  ProjectModel,
  RegisterCustomerRequest,
  ScoreRewardCalculationInformation,
  SelectedDirectPayoutModel,
  ServiceModuleModel,
  SimpleGroupResponse,
  StatusLevelModel,
  StatusSystemServiceModuleModel,
  SubCompanyEmployeeModel,
  SubCompanyModel,
  SurveyAppointmentModuleSubtypeEventModel,
  TaxFreeBenefitBonusShopModuleModel,
  TaxFreeBenefitShopModuleModel,
  TextServiceModuleModel,
  TimeQuotaModel,
  TimeTrackingReportRequest,
  TimesheetModel,
  TimesheetModelPaginatedResponse,
  TimetrackingServiceModuleModel,
  TotalPointsReportingResponse,
  UpdateActionModuleRequest,
  UpdateActionModuleRewardCalculationWalletTypeRequest,
  UpdateCalendarServiceModuleModel,
  UpdateColorRequest,
  UpdateCompanyAbsenceRequest,
  UpdateCompanyManagementUserModel,
  UpdateDocumentExchangeWalletResponse,
  UpdateFileServiceModuleModel,
  UpdateFolderServiceModuleModel,
  UpdateGroupRequest,
  UpdateInsuranceServiceModuleModel,
  UpdateLeaderboardServiceModuleModel,
  UpdatePersonalDocumentsServiceModuleRequest,
  UpdateProjectRequest,
  UpdateServiceModuleModel,
  UpdateShopModuleWalletTypeRequest,
  UpdateStatusLevelModel,
  UpdateStatusSystemServiceModuleModel,
  UpdateTextServiceModuleModel,
  UpdateTimeQuotaRequest,
  UpdateTimesheetCompanyRequest,
  UpdateTimetrackingServiceModuleModel,
  UpdateUrlServiceModuleModel,
  UpdateVacationQuotaRequest,
  UpdateWalletTypeRequest,
  UrlServiceModuleModel,
  UserResponse,
  VacationQuotaModel,
  VoucherShopModuleModel,
  WalletBalancesResponse,
  WalletCompanyResponse,
  WalletTypeResponse
} from '../../model';

import { axiosInstance } from '../../axios-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;





const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiWalletsWalletIdCompany = (
    walletId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<WalletBalancesResponse>(
      {url: `/api/wallets/${walletId}/company`, method: 'GET', signal
    },
      );
    }




export const getGetApiWalletsWalletIdCompanyQueryKey = (walletId: string,) => {
    return [
    `/api/wallets/${walletId}/company`
    ] as const;
    }


export const getGetApiWalletsWalletIdCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError = ErrorResponse>(walletId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWalletsWalletIdCompanyQueryKey(walletId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>> = ({ signal }) => getApiWalletsWalletIdCompany(walletId, signal);





   return  { queryKey, queryFn, enabled: walletId !== null && walletId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWalletsWalletIdCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>>
export type GetApiWalletsWalletIdCompanyQueryError = ErrorResponse


export function useGetApiWalletsWalletIdCompany<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError = ErrorResponse>(
 walletId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWalletsWalletIdCompany<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError = ErrorResponse>(
 walletId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWalletsWalletIdCompany<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError = ErrorResponse>(
 walletId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWalletsWalletIdCompany<TData = Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError = ErrorResponse>(
 walletId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsWalletIdCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWalletsWalletIdCompanyQueryOptions(walletId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiWalletsCompany = (

 signal?: AbortSignal
) => {


      return axiosInstance<WalletCompanyResponse[]>(
      {url: `/api/wallets/company`, method: 'GET', signal
    },
      );
    }




export const getGetApiWalletsCompanyQueryKey = () => {
    return [
    `/api/wallets/company`
    ] as const;
    }


export const getGetApiWalletsCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getApiWalletsCompany>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiWalletsCompanyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiWalletsCompany>>> = ({ signal }) => getApiWalletsCompany(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiWalletsCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiWalletsCompany>>>
export type GetApiWalletsCompanyQueryError = ErrorResponse


export function useGetApiWalletsCompany<TData = Awaited<ReturnType<typeof getApiWalletsCompany>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWalletsCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiWalletsCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWalletsCompany<TData = Awaited<ReturnType<typeof getApiWalletsCompany>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiWalletsCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiWalletsCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiWalletsCompany<TData = Awaited<ReturnType<typeof getApiWalletsCompany>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiWalletsCompany<TData = Awaited<ReturnType<typeof getApiWalletsCompany>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiWalletsCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiWalletsCompanyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentMembers = (

 signal?: AbortSignal
) => {


      return axiosInstance<UserResponse[]>(
      {url: `/api/companies/current/members`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentMembersQueryKey = () => {
    return [
    `/api/companies/current/members`
    ] as const;
    }


export const getGetApiCompaniesCurrentMembersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentMembersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>> = ({ signal }) => getApiCompaniesCurrentMembers(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>>
export type GetApiCompaniesCurrentMembersQueryError = ErrorResponse


export function useGetApiCompaniesCurrentMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentMembersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentAnalysisfiles = (
    params: GetApiCompaniesCurrentAnalysisfilesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyAnalysisFileResponsePaginatedResponse>(
      {url: `/api/companies/current/analysisfiles`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentAnalysisfilesQueryKey = (params?: GetApiCompaniesCurrentAnalysisfilesParams,) => {
    return [
    `/api/companies/current/analysisfiles`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentAnalysisfilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError = ErrorResponse>(params: GetApiCompaniesCurrentAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentAnalysisfilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>> = ({ signal }) => getApiCompaniesCurrentAnalysisfiles(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentAnalysisfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>>
export type GetApiCompaniesCurrentAnalysisfilesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentAnalysisfiles<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAnalysisfilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAnalysisfiles<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAnalysisfiles<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentAnalysisfiles<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAnalysisfilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAnalysisfiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentAnalysisfilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentAuditlogs = (
    params: GetApiCompaniesCurrentAuditlogsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<BaseAuditLogModelPaginatedResponse>(
      {url: `/api/companies/current/auditlogs`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentAuditlogsQueryKey = (params?: GetApiCompaniesCurrentAuditlogsParams,) => {
    return [
    `/api/companies/current/auditlogs`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentAuditlogsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError = ErrorResponse>(params: GetApiCompaniesCurrentAuditlogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentAuditlogsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>> = ({ signal }) => getApiCompaniesCurrentAuditlogs(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentAuditlogsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>>
export type GetApiCompaniesCurrentAuditlogsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentAuditlogs<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAuditlogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAuditlogs<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAuditlogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAuditlogs<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAuditlogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentAuditlogs<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAuditlogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAuditlogs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentAuditlogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrent = (

 signal?: AbortSignal
) => {


      return axiosInstance<CompanyResponse>(
      {url: `/api/companies/current`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentQueryKey = () => {
    return [
    `/api/companies/current`
    ] as const;
    }


export const getGetApiCompaniesCurrentQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrent>>> = ({ signal }) => getApiCompaniesCurrent(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrent>>>
export type GetApiCompaniesCurrentQueryError = ErrorResponse


export function useGetApiCompaniesCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrent>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrent>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrent<TData = Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompanymanagementuser = (
    registerCustomerRequest?: RegisterCustomerRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<LoginSuccessfulResponse>(
      {url: `/api/companymanagementuser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerCustomerRequest, signal
    },
      );
    }




export const getPostApiCompanymanagementuserMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompanymanagementuser>>, TError,{data?: RegisterCustomerRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompanymanagementuser>>, TError,{data?: RegisterCustomerRequest}, TContext> => {

const mutationKey = ['postApiCompanymanagementuser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompanymanagementuser>>, {data?: RegisterCustomerRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompanymanagementuser(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompanymanagementuserMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompanymanagementuser>>>
    export type PostApiCompanymanagementuserMutationBody = RegisterCustomerRequest | undefined
    export type PostApiCompanymanagementuserMutationError = ErrorResponse

    export const usePostApiCompanymanagementuser = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompanymanagementuser>>, TError,{data?: RegisterCustomerRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompanymanagementuser>>,
        TError,
        {data?: RegisterCustomerRequest},
        TContext
      > => {
      return useMutation(getPostApiCompanymanagementuserMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentTaxbenefitgroups = (
    params: GetApiCompaniesCurrentTaxbenefitgroupsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ExtendedGroupResponsePaginatedResponse>(
      {url: `/api/companies/current/taxbenefitgroups`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentTaxbenefitgroupsQueryKey = (params?: GetApiCompaniesCurrentTaxbenefitgroupsParams,) => {
    return [
    `/api/companies/current/taxbenefitgroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentTaxbenefitgroupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError = ErrorResponse>(params: GetApiCompaniesCurrentTaxbenefitgroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentTaxbenefitgroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>> = ({ signal }) => getApiCompaniesCurrentTaxbenefitgroups(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentTaxbenefitgroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>>
export type GetApiCompaniesCurrentTaxbenefitgroupsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentTaxbenefitgroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentTaxbenefitgroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentTaxbenefitgroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentTaxbenefitgroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentTaxbenefitgroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentTaxbenefitgroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentTaxbenefitgroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentTaxbenefitgroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTaxbenefitgroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentTaxbenefitgroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentGroupsFilter = (

 signal?: AbortSignal
) => {


      return axiosInstance<GroupsPageFiltersResponse>(
      {url: `/api/companies/current/groups/filter`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentGroupsFilterQueryKey = () => {
    return [
    `/api/companies/current/groups/filter`
    ] as const;
    }


export const getGetApiCompaniesCurrentGroupsFilterQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentGroupsFilterQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>> = ({ signal }) => getApiCompaniesCurrentGroupsFilter(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentGroupsFilterQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>>
export type GetApiCompaniesCurrentGroupsFilterQueryError = ErrorResponse


export function useGetApiCompaniesCurrentGroupsFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentGroupsFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentGroupsFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentGroupsFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentGroupsFilterQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentGroups = (
    createGroupRequest?: CreateGroupRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<GroupResponse>(
      {url: `/api/companies/current/groups`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createGroupRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentGroupsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentGroups>>, TError,{data?: CreateGroupRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentGroups>>, TError,{data?: CreateGroupRequest}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentGroups'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentGroups>>, {data?: CreateGroupRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesCurrentGroups(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentGroupsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentGroups>>>
    export type PostApiCompaniesCurrentGroupsMutationBody = CreateGroupRequest | undefined
    export type PostApiCompaniesCurrentGroupsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentGroups = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentGroups>>, TError,{data?: CreateGroupRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentGroups>>,
        TError,
        {data?: CreateGroupRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentGroupsMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentGroups = (

 signal?: AbortSignal
) => {


      return axiosInstance<SimpleGroupResponse[]>(
      {url: `/api/companies/current/groups`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentGroupsQueryKey = () => {
    return [
    `/api/companies/current/groups`
    ] as const;
    }


export const getGetApiCompaniesCurrentGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>> = ({ signal }) => getApiCompaniesCurrentGroups(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>>
export type GetApiCompaniesCurrentGroupsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentGroups<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentGroupsGroupIdMembers = (
    groupId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserResponse[]>(
      {url: `/api/companies/current/groups/${groupId}/members`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentGroupsGroupIdMembersQueryKey = (groupId: number,) => {
    return [
    `/api/companies/current/groups/${groupId}/members`
    ] as const;
    }


export const getGetApiCompaniesCurrentGroupsGroupIdMembersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError = ErrorResponse>(groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentGroupsGroupIdMembersQueryKey(groupId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>> = ({ signal }) => getApiCompaniesCurrentGroupsGroupIdMembers(groupId, signal);





   return  { queryKey, queryFn, enabled: groupId !== null && groupId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentGroupsGroupIdMembersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>>
export type GetApiCompaniesCurrentGroupsGroupIdMembersQueryError = ErrorResponse


export function useGetApiCompaniesCurrentGroupsGroupIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError = ErrorResponse>(
 groupId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentGroupsGroupIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError = ErrorResponse>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentGroupsGroupIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError = ErrorResponse>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentGroupsGroupIdMembers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError = ErrorResponse>(
 groupId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentGroupsGroupIdMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentGroupsGroupIdMembersQueryOptions(groupId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentGroupsGroupId = (
    groupId: number,
    updateGroupRequest?: UpdateGroupRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<GroupResponse>(
      {url: `/api/companies/current/groups/${groupId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateGroupRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentGroupsGroupIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentGroupsGroupId>>, TError,{groupId: number;data?: UpdateGroupRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentGroupsGroupId>>, TError,{groupId: number;data?: UpdateGroupRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentGroupsGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentGroupsGroupId>>, {groupId: number;data?: UpdateGroupRequest}> = (props) => {
          const {groupId,data} = props ?? {};

          return  patchApiCompaniesCurrentGroupsGroupId(groupId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentGroupsGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentGroupsGroupId>>>
    export type PatchApiCompaniesCurrentGroupsGroupIdMutationBody = UpdateGroupRequest | undefined
    export type PatchApiCompaniesCurrentGroupsGroupIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentGroupsGroupId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentGroupsGroupId>>, TError,{groupId: number;data?: UpdateGroupRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentGroupsGroupId>>,
        TError,
        {groupId: number;data?: UpdateGroupRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentGroupsGroupIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentGroupsGroupId = (
    groupId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/groups/${groupId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentGroupsGroupIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentGroupsGroupId>>, TError,{groupId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentGroupsGroupId>>, TError,{groupId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentGroupsGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentGroupsGroupId>>, {groupId: number}> = (props) => {
          const {groupId} = props ?? {};

          return  deleteApiCompaniesCurrentGroupsGroupId(groupId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentGroupsGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentGroupsGroupId>>>

    export type DeleteApiCompaniesCurrentGroupsGroupIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentGroupsGroupId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentGroupsGroupId>>, TError,{groupId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentGroupsGroupId>>,
        TError,
        {groupId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentGroupsGroupIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentCompanymanagementusers = (

 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/companymanagementusers`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentCompanymanagementusersQueryKey = () => {
    return [
    `/api/companies/current/companymanagementusers`
    ] as const;
    }


export const getGetApiCompaniesCurrentCompanymanagementusersQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentCompanymanagementusersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>> = ({ signal }) => getApiCompaniesCurrentCompanymanagementusers(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentCompanymanagementusersQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>>
export type GetApiCompaniesCurrentCompanymanagementusersQueryError = ErrorResponse


export function useGetApiCompaniesCurrentCompanymanagementusers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentCompanymanagementusers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentCompanymanagementusers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentCompanymanagementusers<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCompanymanagementusers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentCompanymanagementusersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentCompanymanagementusers = (
    createCompanyManagementUserModel?: CreateCompanyManagementUserModel,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/companymanagementusers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCompanyManagementUserModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentCompanymanagementusersMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentCompanymanagementusers>>, TError,{data?: CreateCompanyManagementUserModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentCompanymanagementusers>>, TError,{data?: CreateCompanyManagementUserModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentCompanymanagementusers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentCompanymanagementusers>>, {data?: CreateCompanyManagementUserModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesCurrentCompanymanagementusers(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentCompanymanagementusersMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentCompanymanagementusers>>>
    export type PostApiCompaniesCurrentCompanymanagementusersMutationBody = CreateCompanyManagementUserModel | undefined
    export type PostApiCompaniesCurrentCompanymanagementusersMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentCompanymanagementusers = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentCompanymanagementusers>>, TError,{data?: CreateCompanyManagementUserModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentCompanymanagementusers>>,
        TError,
        {data?: CreateCompanyManagementUserModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentCompanymanagementusersMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId = (
    companyManagementUserId: string,
    updateCompanyManagementUserModel?: UpdateCompanyManagementUserModel,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/companymanagementusers/${companyManagementUserId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyManagementUserModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, TError,{companyManagementUserId: string;data?: UpdateCompanyManagementUserModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, TError,{companyManagementUserId: string;data?: UpdateCompanyManagementUserModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, {companyManagementUserId: string;data?: UpdateCompanyManagementUserModel}> = (props) => {
          const {companyManagementUserId,data} = props ?? {};

          return  patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId(companyManagementUserId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>>
    export type PatchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationBody = UpdateCompanyManagementUserModel | undefined
    export type PatchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, TError,{companyManagementUserId: string;data?: UpdateCompanyManagementUserModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>,
        TError,
        {companyManagementUserId: string;data?: UpdateCompanyManagementUserModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId = (
    companyManagementUserId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/companymanagementusers/${companyManagementUserId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, TError,{companyManagementUserId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, TError,{companyManagementUserId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, {companyManagementUserId: string}> = (props) => {
          const {companyManagementUserId} = props ?? {};

          return  deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId(companyManagementUserId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>>

    export type DeleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>, TError,{companyManagementUserId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserId>>,
        TError,
        {companyManagementUserId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentCompanymanagementusersCompanyManagementUserIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentEmployeesReportingDoneactionmodules = (
    params?: GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<DoneActionModulesReportingResponse[]>(
      {url: `/api/companies/current/employees/reporting/doneactionmodules`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingDoneactionmodulesQueryKey = (params?: GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams,) => {
    return [
    `/api/companies/current/employees/reporting/doneactionmodules`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingDoneactionmodulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError = ErrorResponse>(params?: GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingDoneactionmodulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingDoneactionmodules(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>>
export type GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingDoneactionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingDoneactionmodulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingDoneactionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingDoneactionmodulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingTotalpoints = (
    params?: GetApiCompaniesCurrentEmployeesReportingTotalpointsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TotalPointsReportingResponse[]>(
      {url: `/api/companies/current/employees/reporting/totalpoints`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingTotalpointsQueryKey = (params?: GetApiCompaniesCurrentEmployeesReportingTotalpointsParams,) => {
    return [
    `/api/companies/current/employees/reporting/totalpoints`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingTotalpointsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError = ErrorResponse>(params?: GetApiCompaniesCurrentEmployeesReportingTotalpointsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingTotalpointsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingTotalpoints(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingTotalpointsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>>
export type GetApiCompaniesCurrentEmployeesReportingTotalpointsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingTotalpoints<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesCurrentEmployeesReportingTotalpointsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingTotalpoints<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingTotalpointsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingTotalpoints<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingTotalpointsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingTotalpoints<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingTotalpointsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingTotalpoints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingTotalpointsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth = (
    year: number,
    month: number,
    params?: GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams,
 signal?: AbortSignal
) => {


      return axiosInstance<AveragePointsReportingResponse[]>(
      {url: `/api/companies/current/employees/reporting/averagepoints/${year}/${month}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthQueryKey = (year: number,
    month: number,
    params?: GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams,) => {
    return [
    `/api/companies/current/employees/reporting/averagepoints/${year}/${month}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError = ErrorResponse>(year: number,
    month: number,
    params?: GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthQueryKey(year,month,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth(year,month,params, signal);





   return  { queryKey, queryFn, enabled: year !== null && year !== undefined && month !== null && month !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>>
export type GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number,
    params: undefined |  GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number,
    params?: GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number,
    params?: GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number,
    params?: GetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingAveragepointsYearMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingAveragepointsYearMonthQueryOptions(year,month,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth = (
    year: number,
    month: number,
 signal?: AbortSignal
) => {


      return axiosInstance<AveragePresenceQuotaReportingResponse[]>(
      {url: `/api/companies/current/employees/reporting/presencequota/${year}/${month}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthQueryKey = (year: number,
    month: number,) => {
    return [
    `/api/companies/current/employees/reporting/presencequota/${year}/${month}`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError = ErrorResponse>(year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthQueryKey(year,month);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth(year,month, signal);





   return  { queryKey, queryFn, enabled: year !== null && year !== undefined && month !== null && month !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>>
export type GetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthQueryOptions(year,month,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId = (
    year: number,
    month: number,
    userId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<number>(
      {url: `/api/companies/current/employees/reporting/presencequota/${year}/${month}/${userId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserIdQueryKey = (year: number,
    month: number,
    userId: string,) => {
    return [
    `/api/companies/current/employees/reporting/presencequota/${year}/${month}/${userId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError = ErrorResponse>(year: number,
    month: number,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserIdQueryKey(year,month,userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId(year,month,userId, signal);





   return  { queryKey, queryFn, enabled: year !== null && year !== undefined && month !== null && month !== undefined && userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>>
export type GetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError = ErrorResponse>(
 year: number,
    month: number,
    userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError = ErrorResponse>(
 year: number,
    month: number,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError = ErrorResponse>(
 year: number,
    month: number,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError = ErrorResponse>(
 year: number,
    month: number,
    userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingPresencequotaYearMonthUserIdQueryOptions(year,month,userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @deprecated
 */
export const getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly = (
    year: number,
    month: number,
 signal?: AbortSignal
) => {


      return axiosInstance<ControlSignatureStatisticsMonthlyResponse>(
      {url: `/api/companies/current/employees/reporting/controlsignature/${year}/${month}/monthly`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthlyQueryKey = (year: number,
    month: number,) => {
    return [
    `/api/companies/current/employees/reporting/controlsignature/${year}/${month}/monthly`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthlyQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError = ErrorResponse>(year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthlyQueryKey(year,month);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly(year,month, signal);





   return  { queryKey, queryFn, enabled: year !== null && year !== undefined && month !== null && month !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthlyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>>
export type GetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthlyQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError = ErrorResponse>(
 year: number,
    month: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthly>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthMonthlyQueryOptions(year,month,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @deprecated
 */
export const getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly = (
    year: number,
    month: number,
 signal?: AbortSignal
) => {


      return axiosInstance<ControlSignatureStatisticsWeeklyResponse[]>(
      {url: `/api/companies/current/employees/reporting/controlsignature/${year}/${month}/weekly`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeeklyQueryKey = (year: number,
    month: number,) => {
    return [
    `/api/companies/current/employees/reporting/controlsignature/${year}/${month}/weekly`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeeklyQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError = ErrorResponse>(year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeeklyQueryKey(year,month);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly(year,month, signal);





   return  { queryKey, queryFn, enabled: year !== null && year !== undefined && month !== null && month !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeeklyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>>
export type GetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeeklyQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError = ErrorResponse>(
 year: number,
    month: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError = ErrorResponse>(
 year: number,
    month: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeekly>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingControlsignatureYearMonthWeeklyQueryOptions(year,month,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingActivatedaccounts = (

 signal?: AbortSignal
) => {


      return axiosInstance<ActivatedAccountsReportingResponse>(
      {url: `/api/companies/current/employees/reporting/activatedaccounts`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingActivatedaccountsQueryKey = () => {
    return [
    `/api/companies/current/employees/reporting/activatedaccounts`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingActivatedaccountsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingActivatedaccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingActivatedaccounts(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingActivatedaccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>>
export type GetApiCompaniesCurrentEmployeesReportingActivatedaccountsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingActivatedaccounts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingActivatedaccounts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingActivatedaccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingEvaluationStars = (
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<AverageStarsAndResponseRateResponse>(
      {url: `/api/companies/current/employees/reporting/evaluationStars`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingEvaluationStarsQueryKey = (params?: GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams,) => {
    return [
    `/api/companies/current/employees/reporting/evaluationStars`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingEvaluationStarsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError = ErrorResponse>(params?: GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingEvaluationStarsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingEvaluationStars(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingEvaluationStarsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>>
export type GetApiCompaniesCurrentEmployeesReportingEvaluationStarsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingEvaluationStars<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingEvaluationStars<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingEvaluationStars<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingEvaluationStars<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentEmployeesReportingEvaluationStarsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationStars>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingEvaluationStarsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays = (

 signal?: AbortSignal
) => {


      return axiosInstance<AverageStarsAndResponseRateResponse>(
      {url: `/api/companies/current/employees/reporting/upcomingBirthdays`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdaysQueryKey = () => {
    return [
    `/api/companies/current/employees/reporting/upcomingBirthdays`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdaysQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdaysQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingUpcomingBirthdaysQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>>
export type GetApiCompaniesCurrentEmployeesReportingUpcomingBirthdaysQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdays<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdays<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdays<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdays<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingBirthdays>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingUpcomingBirthdaysQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries = (

 signal?: AbortSignal
) => {


      return axiosInstance<AverageStarsAndResponseRateResponse>(
      {url: `/api/companies/current/employees/reporting/upcomingAnniversaries`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversariesQueryKey = () => {
    return [
    `/api/companies/current/employees/reporting/upcomingAnniversaries`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversariesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversariesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingUpcomingAnniversariesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>>
export type GetApiCompaniesCurrentEmployeesReportingUpcomingAnniversariesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingUpcomingAnniversaries>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingUpcomingAnniversariesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak = (

 signal?: AbortSignal
) => {


      return axiosInstance<ChecklistAnswerStreakResponse[]>(
      {url: `/api/companies/current/employees/reporting/checklistAnswerStreak`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreakQueryKey = () => {
    return [
    `/api/companies/current/employees/reporting/checklistAnswerStreak`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreakQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreakQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreakQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>>
export type GetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreakQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingChecklistAnswerStreak>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingChecklistAnswerStreakQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId = (
    actionModuleId: number,
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<EvaluationThumbsStatisticsResponse>(
      {url: `/api/companies/current/employees/reporting/evaluationThumbs/${actionModuleId}`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdQueryKey = (actionModuleId: number,
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams,) => {
    return [
    `/api/companies/current/employees/reporting/evaluationThumbs/${actionModuleId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError = ErrorResponse>(actionModuleId: number,
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdQueryKey(actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>> = ({ signal }) => getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId(actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>>
export type GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number,
    params: undefined |  GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number,
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number,
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number,
    params?: GetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesReportingEvaluationThumbsActionModuleIdQueryOptions(actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentCustomizations = (

 signal?: AbortSignal
) => {


      return axiosInstance<CompanyCustomizationsResponse>(
      {url: `/api/companies/current/customizations`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentCustomizationsQueryKey = () => {
    return [
    `/api/companies/current/customizations`
    ] as const;
    }


export const getGetApiCompaniesCurrentCustomizationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentCustomizationsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>> = ({ signal }) => getApiCompaniesCurrentCustomizations(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentCustomizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>>
export type GetApiCompaniesCurrentCustomizationsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentCustomizations<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentCustomizations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentCustomizationsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentCustomizationsColor = (
    updateColorRequest?: UpdateColorRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/customizations/color`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateColorRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentCustomizationsColorMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsColor>>, TError,{data?: UpdateColorRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsColor>>, TError,{data?: UpdateColorRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentCustomizationsColor'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsColor>>, {data?: UpdateColorRequest}> = (props) => {
          const {data} = props ?? {};

          return  patchApiCompaniesCurrentCustomizationsColor(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentCustomizationsColorMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsColor>>>
    export type PatchApiCompaniesCurrentCustomizationsColorMutationBody = UpdateColorRequest | undefined
    export type PatchApiCompaniesCurrentCustomizationsColorMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentCustomizationsColor = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsColor>>, TError,{data?: UpdateColorRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsColor>>,
        TError,
        {data?: UpdateColorRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentCustomizationsColorMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentCustomizationsLogo = (
    patchApiCompaniesCurrentCustomizationsLogoBody?: PatchApiCompaniesCurrentCustomizationsLogoBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(patchApiCompaniesCurrentCustomizationsLogoBody?.File !== undefined) {
 formData.append(`File`, patchApiCompaniesCurrentCustomizationsLogoBody.File);
 }

      return axiosInstance<string>(
      {url: `/api/companies/current/customizations/logo`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentCustomizationsLogoMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsLogo>>, TError,{data?: PatchApiCompaniesCurrentCustomizationsLogoBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsLogo>>, TError,{data?: PatchApiCompaniesCurrentCustomizationsLogoBody}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentCustomizationsLogo'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsLogo>>, {data?: PatchApiCompaniesCurrentCustomizationsLogoBody}> = (props) => {
          const {data} = props ?? {};

          return  patchApiCompaniesCurrentCustomizationsLogo(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentCustomizationsLogoMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsLogo>>>
    export type PatchApiCompaniesCurrentCustomizationsLogoMutationBody = PatchApiCompaniesCurrentCustomizationsLogoBody | undefined
    export type PatchApiCompaniesCurrentCustomizationsLogoMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentCustomizationsLogo = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsLogo>>, TError,{data?: PatchApiCompaniesCurrentCustomizationsLogoBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentCustomizationsLogo>>,
        TError,
        {data?: PatchApiCompaniesCurrentCustomizationsLogoBody},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentCustomizationsLogoMutationOptions(options), queryClient);
    }
    export const patchApiEmployeeEmployeeIdAccountmanagement = (
    employeeId: string,
    employeeUserAccountRequest?: EmployeeUserAccountRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserAccountResponse>(
      {url: `/api/employee/${employeeId}/accountmanagement`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: employeeUserAccountRequest, signal
    },
      );
    }




export const getPatchApiEmployeeEmployeeIdAccountmanagementMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiEmployeeEmployeeIdAccountmanagement>>, TError,{employeeId: string;data?: EmployeeUserAccountRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiEmployeeEmployeeIdAccountmanagement>>, TError,{employeeId: string;data?: EmployeeUserAccountRequest}, TContext> => {

const mutationKey = ['patchApiEmployeeEmployeeIdAccountmanagement'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiEmployeeEmployeeIdAccountmanagement>>, {employeeId: string;data?: EmployeeUserAccountRequest}> = (props) => {
          const {employeeId,data} = props ?? {};

          return  patchApiEmployeeEmployeeIdAccountmanagement(employeeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiEmployeeEmployeeIdAccountmanagementMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiEmployeeEmployeeIdAccountmanagement>>>
    export type PatchApiEmployeeEmployeeIdAccountmanagementMutationBody = EmployeeUserAccountRequest | undefined
    export type PatchApiEmployeeEmployeeIdAccountmanagementMutationError = ErrorResponse

    export const usePatchApiEmployeeEmployeeIdAccountmanagement = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiEmployeeEmployeeIdAccountmanagement>>, TError,{employeeId: string;data?: EmployeeUserAccountRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiEmployeeEmployeeIdAccountmanagement>>,
        TError,
        {employeeId: string;data?: EmployeeUserAccountRequest},
        TContext
      > => {
      return useMutation(getPatchApiEmployeeEmployeeIdAccountmanagementMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentAccountmanagementEmployeesFilter = (

 signal?: AbortSignal
) => {


      return axiosInstance<EmployeePageFiltersResponse>(
      {url: `/api/companies/current/accountmanagement/employees/filter`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentAccountmanagementEmployeesFilterQueryKey = () => {
    return [
    `/api/companies/current/accountmanagement/employees/filter`
    ] as const;
    }


export const getGetApiCompaniesCurrentAccountmanagementEmployeesFilterQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentAccountmanagementEmployeesFilterQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>> = ({ signal }) => getApiCompaniesCurrentAccountmanagementEmployeesFilter(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentAccountmanagementEmployeesFilterQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>>
export type GetApiCompaniesCurrentAccountmanagementEmployeesFilterQueryError = ErrorResponse


export function useGetApiCompaniesCurrentAccountmanagementEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAccountmanagementEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAccountmanagementEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentAccountmanagementEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployeesFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentAccountmanagementEmployeesFilterQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentAccountmanagementEmployees = (
    params: GetApiCompaniesCurrentAccountmanagementEmployeesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserResponsePaginatedResponse>(
      {url: `/api/companies/current/accountmanagement/employees`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentAccountmanagementEmployeesQueryKey = (params?: GetApiCompaniesCurrentAccountmanagementEmployeesParams,) => {
    return [
    `/api/companies/current/accountmanagement/employees`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentAccountmanagementEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError = ErrorResponse>(params: GetApiCompaniesCurrentAccountmanagementEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentAccountmanagementEmployeesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>> = ({ signal }) => getApiCompaniesCurrentAccountmanagementEmployees(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentAccountmanagementEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>>
export type GetApiCompaniesCurrentAccountmanagementEmployeesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentAccountmanagementEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAccountmanagementEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAccountmanagementEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAccountmanagementEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentAccountmanagementEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAccountmanagementEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentAccountmanagementEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentAccountmanagementEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentAccountmanagementEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentAccountmanagementEmployeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentAccountmanagementEmployeesbyids = (
    params: PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams,
    postApiCompaniesCurrentAccountmanagementEmployeesbyidsBody?: string[],
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserResponsePaginatedResponseWithIds>(
      {url: `/api/companies/current/accountmanagement/employeesbyids`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiCompaniesCurrentAccountmanagementEmployeesbyidsBody,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentAccountmanagementEmployeesbyidsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentAccountmanagementEmployeesbyids>>, TError,{params: PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams;data?: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentAccountmanagementEmployeesbyids>>, TError,{params: PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams;data?: string[]}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentAccountmanagementEmployeesbyids'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentAccountmanagementEmployeesbyids>>, {params: PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams;data?: string[]}> = (props) => {
          const {params,data} = props ?? {};

          return  postApiCompaniesCurrentAccountmanagementEmployeesbyids(params,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentAccountmanagementEmployeesbyidsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentAccountmanagementEmployeesbyids>>>
    export type PostApiCompaniesCurrentAccountmanagementEmployeesbyidsMutationBody = string[] | undefined
    export type PostApiCompaniesCurrentAccountmanagementEmployeesbyidsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentAccountmanagementEmployeesbyids = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentAccountmanagementEmployeesbyids>>, TError,{params: PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams;data?: string[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentAccountmanagementEmployeesbyids>>,
        TError,
        {params: PostApiCompaniesCurrentAccountmanagementEmployeesbyidsParams;data?: string[]},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentAccountmanagementEmployeesbyidsMutationOptions(options), queryClient);
    }
    export const getApiCompanymanagementuserOnboardingfiles = (

 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companymanagementuser/onboardingfiles`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompanymanagementuserOnboardingfilesQueryKey = () => {
    return [
    `/api/companymanagementuser/onboardingfiles`
    ] as const;
    }


export const getGetApiCompanymanagementuserOnboardingfilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompanymanagementuserOnboardingfilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>> = ({ signal }) => getApiCompanymanagementuserOnboardingfiles(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompanymanagementuserOnboardingfilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>>
export type GetApiCompanymanagementuserOnboardingfilesQueryError = ErrorResponse


export function useGetApiCompanymanagementuserOnboardingfiles<TData = Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompanymanagementuserOnboardingfiles<TData = Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>,
          TError,
          Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompanymanagementuserOnboardingfiles<TData = Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompanymanagementuserOnboardingfiles<TData = Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompanymanagementuserOnboardingfiles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompanymanagementuserOnboardingfilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId = (
    documentExchangeWalletId: number,
    groupId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/group/${groupId}`, method: 'POST', signal
    },
      );
    }




export const getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, TError,{documentExchangeWalletId: number;groupId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, TError,{documentExchangeWalletId: number;groupId: number}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, {documentExchangeWalletId: number;groupId: number}> = (props) => {
          const {documentExchangeWalletId,groupId} = props ?? {};

          return  postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId(documentExchangeWalletId,groupId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>>

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, TError,{documentExchangeWalletId: number;groupId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>,
        TError,
        {documentExchangeWalletId: number;groupId: number},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId = (
    documentExchangeWalletId: number,
    groupId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/group/${groupId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, TError,{documentExchangeWalletId: number;groupId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, TError,{documentExchangeWalletId: number;groupId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, {documentExchangeWalletId: number;groupId: number}> = (props) => {
          const {documentExchangeWalletId,groupId} = props ?? {};

          return  deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId(documentExchangeWalletId,groupId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>>

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>, TError,{documentExchangeWalletId: number;groupId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupId>>,
        TError,
        {documentExchangeWalletId: number;groupId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdGroupGroupIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId = (
    documentExchangeWalletId: number,
    userId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/user/${userId}`, method: 'POST', signal
    },
      );
    }




export const getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, TError,{documentExchangeWalletId: number;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, TError,{documentExchangeWalletId: number;userId: string}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, {documentExchangeWalletId: number;userId: string}> = (props) => {
          const {documentExchangeWalletId,userId} = props ?? {};

          return  postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId(documentExchangeWalletId,userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>>

    export type PostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, TError,{documentExchangeWalletId: number;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>,
        TError,
        {documentExchangeWalletId: number;userId: string},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId = (
    documentExchangeWalletId: number,
    userId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<UpdateDocumentExchangeWalletResponse>(
      {url: `/api/companies/current/fileexchange/${documentExchangeWalletId}/user/${userId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, TError,{documentExchangeWalletId: number;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, TError,{documentExchangeWalletId: number;userId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, {documentExchangeWalletId: number;userId: string}> = (props) => {
          const {documentExchangeWalletId,userId} = props ?? {};

          return  deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId(documentExchangeWalletId,userId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>>

    export type DeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>, TError,{documentExchangeWalletId: number;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserId>>,
        TError,
        {documentExchangeWalletId: number;userId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentFileexchangeDocumentExchangeWalletIdUserUserIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentInvoices = (
    params: GetApiCompaniesCurrentInvoicesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<CompanyInvoiceFileResponsePaginatedResponse>(
      {url: `/api/companies/current/invoices`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentInvoicesQueryKey = (params?: GetApiCompaniesCurrentInvoicesParams,) => {
    return [
    `/api/companies/current/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError = ErrorResponse>(params: GetApiCompaniesCurrentInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>> = ({ signal }) => getApiCompaniesCurrentInvoices(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>>
export type GetApiCompaniesCurrentInvoicesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentInvoices<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentInvoices<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentInvoices<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentInvoices<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentInvoices>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentSubcompanies = (

 signal?: AbortSignal
) => {


      return axiosInstance<SubCompanyModel[]>(
      {url: `/api/companies/current/subcompanies`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentSubcompaniesQueryKey = () => {
    return [
    `/api/companies/current/subcompanies`
    ] as const;
    }


export const getGetApiCompaniesCurrentSubcompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentSubcompaniesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>> = ({ signal }) => getApiCompaniesCurrentSubcompanies(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentSubcompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>>
export type GetApiCompaniesCurrentSubcompaniesQueryError = unknown


export function useGetApiCompaniesCurrentSubcompanies<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentSubcompanies<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentSubcompanies<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentSubcompanies<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompanies>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentSubcompaniesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentSubcompanies = (
    createSubCompanyModel?: CreateSubCompanyModel,
 signal?: AbortSignal
) => {


      return axiosInstance<SubCompanyModel>(
      {url: `/api/companies/current/subcompanies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubCompanyModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentSubcompaniesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompanies>>, TError,{data?: CreateSubCompanyModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompanies>>, TError,{data?: CreateSubCompanyModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentSubcompanies'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompanies>>, {data?: CreateSubCompanyModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesCurrentSubcompanies(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentSubcompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompanies>>>
    export type PostApiCompaniesCurrentSubcompaniesMutationBody = CreateSubCompanyModel | undefined
    export type PostApiCompaniesCurrentSubcompaniesMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentSubcompanies = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompanies>>, TError,{data?: CreateSubCompanyModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompanies>>,
        TError,
        {data?: CreateSubCompanyModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentSubcompaniesMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentSubcompaniesSubCompanyId = (
    subCompanyId: number,
    createSubCompanyModel?: CreateSubCompanyModel,
 signal?: AbortSignal
) => {


      return axiosInstance<SubCompanyModel>(
      {url: `/api/companies/current/subcompanies/${subCompanyId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: createSubCompanyModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentSubcompaniesSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentSubcompaniesSubCompanyId>>, TError,{subCompanyId: number;data?: CreateSubCompanyModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentSubcompaniesSubCompanyId>>, TError,{subCompanyId: number;data?: CreateSubCompanyModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentSubcompaniesSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentSubcompaniesSubCompanyId>>, {subCompanyId: number;data?: CreateSubCompanyModel}> = (props) => {
          const {subCompanyId,data} = props ?? {};

          return  patchApiCompaniesCurrentSubcompaniesSubCompanyId(subCompanyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentSubcompaniesSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentSubcompaniesSubCompanyId>>>
    export type PatchApiCompaniesCurrentSubcompaniesSubCompanyIdMutationBody = CreateSubCompanyModel | undefined
    export type PatchApiCompaniesCurrentSubcompaniesSubCompanyIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentSubcompaniesSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentSubcompaniesSubCompanyId>>, TError,{subCompanyId: number;data?: CreateSubCompanyModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentSubcompaniesSubCompanyId>>,
        TError,
        {subCompanyId: number;data?: CreateSubCompanyModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentSubcompaniesSubCompanyIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentSubcompaniesSubCompanyId = (
    subCompanyId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/subcompanies/${subCompanyId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyId>>, TError,{subCompanyId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyId>>, TError,{subCompanyId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentSubcompaniesSubCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyId>>, {subCompanyId: number}> = (props) => {
          const {subCompanyId} = props ?? {};

          return  deleteApiCompaniesCurrentSubcompaniesSubCompanyId(subCompanyId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyId>>>

    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentSubcompaniesSubCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyId>>, TError,{subCompanyId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyId>>,
        TError,
        {subCompanyId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees = (
    subCompanyId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserResponse[]>(
      {url: `/api/companies/current/subcompanies/${subCompanyId}/employees`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesQueryKey = (subCompanyId: number,) => {
    return [
    `/api/companies/current/subcompanies/${subCompanyId}/employees`
    ] as const;
    }


export const getGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError = ErrorResponse>(subCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesQueryKey(subCompanyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>> = ({ signal }) => getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees(subCompanyId, signal);





   return  { queryKey, queryFn, enabled: subCompanyId !== null && subCompanyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>>
export type GetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError = ErrorResponse>(
 subCompanyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError = ErrorResponse>(
 subCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError = ErrorResponse>(
 subCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError = ErrorResponse>(
 subCompanyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentSubcompaniesSubCompanyIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesQueryOptions(subCompanyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee = (
    subCompanyId: number,
    subCompanyEmployeeModel?: SubCompanyEmployeeModel,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/subcompanies/${subCompanyId}/employee`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: subCompanyEmployeeModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, TError,{subCompanyId: number;data?: SubCompanyEmployeeModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, TError,{subCompanyId: number;data?: SubCompanyEmployeeModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, {subCompanyId: number;data?: SubCompanyEmployeeModel}> = (props) => {
          const {subCompanyId,data} = props ?? {};

          return  postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee(subCompanyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>>
    export type PostApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationBody = SubCompanyEmployeeModel | undefined
    export type PostApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, TError,{subCompanyId: number;data?: SubCompanyEmployeeModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>,
        TError,
        {subCompanyId: number;data?: SubCompanyEmployeeModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee = (
    subCompanyId: number,
    subCompanyEmployeeModel?: SubCompanyEmployeeModel,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/subcompanies/${subCompanyId}/employee`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: subCompanyEmployeeModel, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, TError,{subCompanyId: number;data?: SubCompanyEmployeeModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, TError,{subCompanyId: number;data?: SubCompanyEmployeeModel}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, {subCompanyId: number;data?: SubCompanyEmployeeModel}> = (props) => {
          const {subCompanyId,data} = props ?? {};

          return  deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee(subCompanyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>>
    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationBody = SubCompanyEmployeeModel | undefined
    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>, TError,{subCompanyId: number;data?: SubCompanyEmployeeModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployee>>,
        TError,
        {subCompanyId: number;data?: SubCompanyEmployeeModel},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeeMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId = (
    subCompanyId: number,
    employeeUserId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/subcompanies/${subCompanyId}/employees/${employeeUserId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId>>, TError,{subCompanyId: number;employeeUserId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId>>, TError,{subCompanyId: number;employeeUserId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId>>, {subCompanyId: number;employeeUserId: string}> = (props) => {
          const {subCompanyId,employeeUserId} = props ?? {};

          return  deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId(subCompanyId,employeeUserId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId>>>

    export type DeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId>>, TError,{subCompanyId: number;employeeUserId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserId>>,
        TError,
        {subCompanyId: number;employeeUserId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentSubcompaniesSubCompanyIdEmployeesEmployeeUserIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesWalletTypes = (

 signal?: AbortSignal
) => {


      return axiosInstance<WalletTypeResponse[]>(
      {url: `/api/companies/wallet-types`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesWalletTypesQueryKey = () => {
    return [
    `/api/companies/wallet-types`
    ] as const;
    }


export const getGetApiCompaniesWalletTypesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesWalletTypesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>> = ({ signal }) => getApiCompaniesWalletTypes(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesWalletTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>>
export type GetApiCompaniesWalletTypesQueryError = ErrorResponse


export function useGetApiCompaniesWalletTypes<TData = Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesWalletTypes<TData = Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesWalletTypes<TData = Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesWalletTypes<TData = Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesWalletTypes>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesWalletTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesWalletTypes = (
    createWalletTypeRequest?: CreateWalletTypeRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<WalletTypeResponse>(
      {url: `/api/companies/wallet-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createWalletTypeRequest, signal
    },
      );
    }




export const getPostApiCompaniesWalletTypesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesWalletTypes>>, TError,{data?: CreateWalletTypeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesWalletTypes>>, TError,{data?: CreateWalletTypeRequest}, TContext> => {

const mutationKey = ['postApiCompaniesWalletTypes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesWalletTypes>>, {data?: CreateWalletTypeRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesWalletTypes(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesWalletTypesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesWalletTypes>>>
    export type PostApiCompaniesWalletTypesMutationBody = CreateWalletTypeRequest | undefined
    export type PostApiCompaniesWalletTypesMutationError = ErrorResponse

    export const usePostApiCompaniesWalletTypes = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesWalletTypes>>, TError,{data?: CreateWalletTypeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesWalletTypes>>,
        TError,
        {data?: CreateWalletTypeRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesWalletTypesMutationOptions(options), queryClient);
    }
    export const putApiCompaniesWalletTypesWalletTypeId = (
    walletTypeId: string,
    updateWalletTypeRequest?: UpdateWalletTypeRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<WalletTypeResponse>(
      {url: `/api/companies/wallet-types/${walletTypeId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateWalletTypeRequest, signal
    },
      );
    }




export const getPutApiCompaniesWalletTypesWalletTypeIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesWalletTypesWalletTypeId>>, TError,{walletTypeId: string;data?: UpdateWalletTypeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesWalletTypesWalletTypeId>>, TError,{walletTypeId: string;data?: UpdateWalletTypeRequest}, TContext> => {

const mutationKey = ['putApiCompaniesWalletTypesWalletTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiCompaniesWalletTypesWalletTypeId>>, {walletTypeId: string;data?: UpdateWalletTypeRequest}> = (props) => {
          const {walletTypeId,data} = props ?? {};

          return  putApiCompaniesWalletTypesWalletTypeId(walletTypeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiCompaniesWalletTypesWalletTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiCompaniesWalletTypesWalletTypeId>>>
    export type PutApiCompaniesWalletTypesWalletTypeIdMutationBody = UpdateWalletTypeRequest | undefined
    export type PutApiCompaniesWalletTypesWalletTypeIdMutationError = ErrorResponse

    export const usePutApiCompaniesWalletTypesWalletTypeId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesWalletTypesWalletTypeId>>, TError,{walletTypeId: string;data?: UpdateWalletTypeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiCompaniesWalletTypesWalletTypeId>>,
        TError,
        {walletTypeId: string;data?: UpdateWalletTypeRequest},
        TContext
      > => {
      return useMutation(getPutApiCompaniesWalletTypesWalletTypeIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesWalletTypesWalletTypeId = (
    walletTypeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/wallet-types/${walletTypeId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesWalletTypesWalletTypeIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesWalletTypesWalletTypeId>>, TError,{walletTypeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesWalletTypesWalletTypeId>>, TError,{walletTypeId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesWalletTypesWalletTypeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesWalletTypesWalletTypeId>>, {walletTypeId: string}> = (props) => {
          const {walletTypeId} = props ?? {};

          return  deleteApiCompaniesWalletTypesWalletTypeId(walletTypeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesWalletTypesWalletTypeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesWalletTypesWalletTypeId>>>

    export type DeleteApiCompaniesWalletTypesWalletTypeIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesWalletTypesWalletTypeId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesWalletTypesWalletTypeId>>, TError,{walletTypeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesWalletTypesWalletTypeId>>,
        TError,
        {walletTypeId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesWalletTypesWalletTypeIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentShopmodules = (

 signal?: AbortSignal
) => {


      return axiosInstance<(BaseShopModuleModel | TaxFreeBenefitShopModuleModel | TaxFreeBenefitBonusShopModuleModel | DirectPayoutShopModuleModel | CompanyPensionShopModuleModel | VoucherShopModuleModel | FullPayoutShopModuleModel)[]>(
      {url: `/api/companies/current/shopmodules`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentShopmodulesQueryKey = () => {
    return [
    `/api/companies/current/shopmodules`
    ] as const;
    }


export const getGetApiCompaniesCurrentShopmodulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentShopmodulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>> = ({ signal }) => getApiCompaniesCurrentShopmodules(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentShopmodulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>>
export type GetApiCompaniesCurrentShopmodulesQueryError = unknown


export function useGetApiCompaniesCurrentShopmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentShopmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentShopmodulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentShopmodulesFiltered = (
    params?: GetApiCompaniesCurrentShopmodulesFilteredParams,
 signal?: AbortSignal
) => {


      return axiosInstance<(BaseShopModuleModel | TaxFreeBenefitShopModuleModel | TaxFreeBenefitBonusShopModuleModel | DirectPayoutShopModuleModel | CompanyPensionShopModuleModel | VoucherShopModuleModel | FullPayoutShopModuleModel)[]>(
      {url: `/api/companies/current/shopmodules/filtered`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentShopmodulesFilteredQueryKey = (params?: GetApiCompaniesCurrentShopmodulesFilteredParams,) => {
    return [
    `/api/companies/current/shopmodules/filtered`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentShopmodulesFilteredQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError = unknown>(params?: GetApiCompaniesCurrentShopmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentShopmodulesFilteredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>> = ({ signal }) => getApiCompaniesCurrentShopmodulesFiltered(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentShopmodulesFilteredQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>>
export type GetApiCompaniesCurrentShopmodulesFilteredQueryError = unknown


export function useGetApiCompaniesCurrentShopmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError = unknown>(
 params: undefined |  GetApiCompaniesCurrentShopmodulesFilteredParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError = unknown>(
 params?: GetApiCompaniesCurrentShopmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError = unknown>(
 params?: GetApiCompaniesCurrentShopmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentShopmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError = unknown>(
 params?: GetApiCompaniesCurrentShopmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFiltered>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentShopmodulesFilteredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiCompaniesCurrentShopmodulesShopModuleIdWalletType = (
    shopModuleId: number,
    updateShopModuleWalletTypeRequest?: UpdateShopModuleWalletTypeRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/shopmodules/${shopModuleId}/wallet-type`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateShopModuleWalletTypeRequest, signal
    },
      );
    }




export const getPutApiCompaniesCurrentShopmodulesShopModuleIdWalletTypeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentShopmodulesShopModuleIdWalletType>>, TError,{shopModuleId: number;data?: UpdateShopModuleWalletTypeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentShopmodulesShopModuleIdWalletType>>, TError,{shopModuleId: number;data?: UpdateShopModuleWalletTypeRequest}, TContext> => {

const mutationKey = ['putApiCompaniesCurrentShopmodulesShopModuleIdWalletType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiCompaniesCurrentShopmodulesShopModuleIdWalletType>>, {shopModuleId: number;data?: UpdateShopModuleWalletTypeRequest}> = (props) => {
          const {shopModuleId,data} = props ?? {};

          return  putApiCompaniesCurrentShopmodulesShopModuleIdWalletType(shopModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiCompaniesCurrentShopmodulesShopModuleIdWalletTypeMutationResult = NonNullable<Awaited<ReturnType<typeof putApiCompaniesCurrentShopmodulesShopModuleIdWalletType>>>
    export type PutApiCompaniesCurrentShopmodulesShopModuleIdWalletTypeMutationBody = UpdateShopModuleWalletTypeRequest | undefined
    export type PutApiCompaniesCurrentShopmodulesShopModuleIdWalletTypeMutationError = ErrorResponse

    export const usePutApiCompaniesCurrentShopmodulesShopModuleIdWalletType = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentShopmodulesShopModuleIdWalletType>>, TError,{shopModuleId: number;data?: UpdateShopModuleWalletTypeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiCompaniesCurrentShopmodulesShopModuleIdWalletType>>,
        TError,
        {shopModuleId: number;data?: UpdateShopModuleWalletTypeRequest},
        TContext
      > => {
      return useMutation(getPutApiCompaniesCurrentShopmodulesShopModuleIdWalletTypeMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts = (
    shopModuleId: number,
    params: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<FullPayoutBatchModelPaginatedResponse>(
      {url: `/api/companies/current/shopmodules/fullpayout/${shopModuleId}/payouts`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsQueryKey = (shopModuleId: number,
    params?: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams,) => {
    return [
    `/api/companies/current/shopmodules/fullpayout/${shopModuleId}/payouts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError = unknown>(shopModuleId: number,
    params: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsQueryKey(shopModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>> = ({ signal }) => getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts(shopModuleId,params, signal);





   return  { queryKey, queryFn, enabled: shopModuleId !== null && shopModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>>
export type GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsQueryError = unknown


export function useGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError = unknown>(
 shopModuleId: number,
    params: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError = unknown>(
 shopModuleId: number,
    params: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError = unknown>(
 shopModuleId: number,
    params: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError = unknown>(
 shopModuleId: number,
    params: GetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayouts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentShopmodulesFullpayoutShopModuleIdPayoutsQueryOptions(shopModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentShopmodulesFullpayout = (

 signal?: AbortSignal
) => {


      return axiosInstance<FullPayoutShopModuleOverviewModel[]>(
      {url: `/api/companies/current/shopmodules/fullpayout`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentShopmodulesFullpayoutQueryKey = () => {
    return [
    `/api/companies/current/shopmodules/fullpayout`
    ] as const;
    }


export const getGetApiCompaniesCurrentShopmodulesFullpayoutQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentShopmodulesFullpayoutQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>> = ({ signal }) => getApiCompaniesCurrentShopmodulesFullpayout(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentShopmodulesFullpayoutQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>>
export type GetApiCompaniesCurrentShopmodulesFullpayoutQueryError = unknown


export function useGetApiCompaniesCurrentShopmodulesFullpayout<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodulesFullpayout<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentShopmodulesFullpayout<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentShopmodulesFullpayout<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentShopmodulesFullpayout>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentShopmodulesFullpayoutQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getPayouts = (
    params?: GetPayoutsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<SelectedDirectPayoutModel[]>(
      {url: `/payouts`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetPayoutsQueryKey = (params?: GetPayoutsParams,) => {
    return [
    `/payouts`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPayoutsQueryOptions = <TData = Awaited<ReturnType<typeof getPayouts>>, TError = unknown>(params?: GetPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayoutsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayouts>>> = ({ signal }) => getPayouts(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayouts>>>
export type GetPayoutsQueryError = unknown


export function useGetPayouts<TData = Awaited<ReturnType<typeof getPayouts>>, TError = unknown>(
 params: undefined |  GetPayoutsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayouts>>,
          TError,
          Awaited<ReturnType<typeof getPayouts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayouts<TData = Awaited<ReturnType<typeof getPayouts>>, TError = unknown>(
 params?: GetPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayouts>>,
          TError,
          Awaited<ReturnType<typeof getPayouts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayouts<TData = Awaited<ReturnType<typeof getPayouts>>, TError = unknown>(
 params?: GetPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPayouts<TData = Awaited<ReturnType<typeof getPayouts>>, TError = unknown>(
 params?: GetPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayouts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayoutsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodules = (

 signal?: AbortSignal
) => {


      return axiosInstance<(ServiceModuleModel | CalendarServiceModuleModel | FileServiceModuleModel | FolderServiceModuleModel | TextServiceModuleModel | UrlServiceModuleModel | LeaderboardServiceModuleModel | TimetrackingServiceModuleModel | AbsenceServiceModuleModel | PersonalDocumentsServiceModuleModel | StatusSystemServiceModuleModel | InsuranceServiceModuleModel)[]>(
      {url: `/api/companies/current/servicemodules`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesQueryKey = () => {
    return [
    `/api/companies/current/servicemodules`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>> = ({ signal }) => getApiCompaniesCurrentServicemodules(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>>
export type GetApiCompaniesCurrentServicemodulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentServicemodules = (
    createServiceModuleModel?: CreateServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<ServiceModuleModel | CalendarServiceModuleModel | FileServiceModuleModel | FolderServiceModuleModel | TextServiceModuleModel | UrlServiceModuleModel | LeaderboardServiceModuleModel | TimetrackingServiceModuleModel | AbsenceServiceModuleModel | PersonalDocumentsServiceModuleModel | StatusSystemServiceModuleModel | InsuranceServiceModuleModel>(
      {url: `/api/companies/current/servicemodules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createServiceModuleModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodules>>, TError,{data?: CreateServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodules>>, TError,{data?: CreateServiceModuleModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodules>>, {data?: CreateServiceModuleModel}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesCurrentServicemodules(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodules>>>
    export type PostApiCompaniesCurrentServicemodulesMutationBody = CreateServiceModuleModel | undefined
    export type PostApiCompaniesCurrentServicemodulesMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodules = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodules>>, TError,{data?: CreateServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodules>>,
        TError,
        {data?: CreateServiceModuleModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesFiltered = (
    params?: GetApiCompaniesCurrentServicemodulesFilteredParams,
 signal?: AbortSignal
) => {


      return axiosInstance<(ServiceModuleModel | CalendarServiceModuleModel | FileServiceModuleModel | FolderServiceModuleModel | TextServiceModuleModel | UrlServiceModuleModel | LeaderboardServiceModuleModel | TimetrackingServiceModuleModel | AbsenceServiceModuleModel | PersonalDocumentsServiceModuleModel | StatusSystemServiceModuleModel | InsuranceServiceModuleModel)[]>(
      {url: `/api/companies/current/servicemodules/filtered`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesFilteredQueryKey = (params?: GetApiCompaniesCurrentServicemodulesFilteredParams,) => {
    return [
    `/api/companies/current/servicemodules/filtered`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesFilteredQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError = ErrorResponse>(params?: GetApiCompaniesCurrentServicemodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesFilteredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesFiltered(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesFilteredQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>>
export type GetApiCompaniesCurrentServicemodulesFilteredQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesCurrentServicemodulesFilteredParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentServicemodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentServicemodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentServicemodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFiltered>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesFilteredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesOrder = (
    patchApiCompaniesCurrentServicemodulesOrderBody?: number[],
 signal?: AbortSignal
) => {


      return axiosInstance<number[]>(
      {url: `/api/companies/current/servicemodules/order`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiCompaniesCurrentServicemodulesOrderBody, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesOrderMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesOrder>>, TError,{data?: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesOrder>>, TError,{data?: number[]}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesOrder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesOrder>>, {data?: number[]}> = (props) => {
          const {data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesOrder(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesOrderMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesOrder>>>
    export type PatchApiCompaniesCurrentServicemodulesOrderMutationBody = number[] | undefined
    export type PatchApiCompaniesCurrentServicemodulesOrderMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesOrder = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesOrder>>, TError,{data?: number[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesOrder>>,
        TError,
        {data?: number[]},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesOrderMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<(ServiceModuleModel | CalendarServiceModuleModel | FileServiceModuleModel | FolderServiceModuleModel | TextServiceModuleModel | UrlServiceModuleModel | LeaderboardServiceModuleModel | TimetrackingServiceModuleModel | AbsenceServiceModuleModel | PersonalDocumentsServiceModuleModel | StatusSystemServiceModuleModel | InsuranceServiceModuleModel)[]>(
      {url: `/api/companies/current/servicemodules/${serviceModuleId}/descendants`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendantsQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/${serviceModuleId}/descendants`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendantsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendantsQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesServiceModuleIdDescendantsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>>
export type GetApiCompaniesCurrentServicemodulesServiceModuleIdDescendantsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendants<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendants<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendants<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendants<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdDescendants>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesServiceModuleIdDescendantsQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesParent = (
    params?: PatchApiCompaniesCurrentServicemodulesParentParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/parent`, method: 'PATCH',
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesParentMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesParent>>, TError,{params?: PatchApiCompaniesCurrentServicemodulesParentParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesParent>>, TError,{params?: PatchApiCompaniesCurrentServicemodulesParentParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesParent'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesParent>>, {params?: PatchApiCompaniesCurrentServicemodulesParentParams}> = (props) => {
          const {params} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesParent(params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesParentMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesParent>>>

    export type PatchApiCompaniesCurrentServicemodulesParentMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesParent = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesParent>>, TError,{params?: PatchApiCompaniesCurrentServicemodulesParentParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesParent>>,
        TError,
        {params?: PatchApiCompaniesCurrentServicemodulesParentParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesParentMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesServiceModuleId = (
    serviceModuleId: number,
    updateServiceModuleModel?: UpdateServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<ServiceModuleModel | CalendarServiceModuleModel | FileServiceModuleModel | FolderServiceModuleModel | TextServiceModuleModel | UrlServiceModuleModel | LeaderboardServiceModuleModel | TimetrackingServiceModuleModel | AbsenceServiceModuleModel | PersonalDocumentsServiceModuleModel | StatusSystemServiceModuleModel | InsuranceServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesServiceModuleId>>, {serviceModuleId: number;data?: UpdateServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesServiceModuleIdMutationBody = UpdateServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesServiceModuleIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/${serviceModuleId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesServiceModuleId>>, TError,{serviceModuleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesServiceModuleId>>, TError,{serviceModuleId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesServiceModuleId>>, {serviceModuleId: number}> = (props) => {
          const {serviceModuleId} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesServiceModuleId(serviceModuleId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesServiceModuleId>>>

    export type DeleteApiCompaniesCurrentServicemodulesServiceModuleIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesServiceModuleId>>, TError,{serviceModuleId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesServiceModuleId>>,
        TError,
        {serviceModuleId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesServiceModuleIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserResponse[]>(
      {url: `/api/companies/current/servicemodules/${serviceModuleId}/employees`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployeesQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/${serviceModuleId}/employees`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployeesQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesServiceModuleIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>>
export type GetApiCompaniesCurrentServicemodulesServiceModuleIdEmployeesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesServiceModuleIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesServiceModuleIdEmployeesQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesIdIcon = (
    id: number,
    patchApiCompaniesCurrentServicemodulesIdIconBody?: PatchApiCompaniesCurrentServicemodulesIdIconBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(patchApiCompaniesCurrentServicemodulesIdIconBody?.File !== undefined) {
 formData.append(`File`, patchApiCompaniesCurrentServicemodulesIdIconBody.File);
 }

      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/${id}/icon`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesIdIconMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesIdIcon>>, TError,{id: number;data?: PatchApiCompaniesCurrentServicemodulesIdIconBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesIdIcon>>, TError,{id: number;data?: PatchApiCompaniesCurrentServicemodulesIdIconBody}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesIdIcon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesIdIcon>>, {id: number;data?: PatchApiCompaniesCurrentServicemodulesIdIconBody}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesIdIcon(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesIdIconMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesIdIcon>>>
    export type PatchApiCompaniesCurrentServicemodulesIdIconMutationBody = PatchApiCompaniesCurrentServicemodulesIdIconBody | undefined
    export type PatchApiCompaniesCurrentServicemodulesIdIconMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesIdIcon = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesIdIcon>>, TError,{id: number;data?: PatchApiCompaniesCurrentServicemodulesIdIconBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesIdIcon>>,
        TError,
        {id: number;data?: PatchApiCompaniesCurrentServicemodulesIdIconBody},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesIdIconMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const getApiCompaniesCurrentServicemodulestore = (

 signal?: AbortSignal
) => {


      return axiosInstance<CompanyAssignedStoreEntryModel[]>(
      {url: `/api/companies/current/servicemodulestore`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulestoreQueryKey = () => {
    return [
    `/api/companies/current/servicemodulestore`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulestoreQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulestoreQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>> = ({ signal }) => getApiCompaniesCurrentServicemodulestore(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulestoreQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>>
export type GetApiCompaniesCurrentServicemodulestoreQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulestore<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulestore<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulestore<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCurrentServicemodulestore<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulestore>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulestoreQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated = (
    serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams,
 signal?: AbortSignal
) => {


      return axiosInstance<AbsenceModelPaginatedResponse>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/absences/company/paginated`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams,) => {
    return [
    `/api/companies/current/servicemodules/absence/${serviceModuleId}/absences/company/paginated`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError = ErrorResponse>(serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>>
export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginated>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyPaginatedQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams,
 signal?: AbortSignal
) => {


      return axiosInstance<AbsenceModel[]>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/absences/company`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams,) => {
    return [
    `/api/companies/current/servicemodules/absence/${serviceModuleId}/absences/company`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>>
export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId = (
    serviceModuleId: number,
    id: number,
    updateCompanyAbsenceRequest?: UpdateCompanyAbsenceRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<AbsenceModel>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/absences/company/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyAbsenceRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId>>, TError,{serviceModuleId: number;id: number;data?: UpdateCompanyAbsenceRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId>>, TError,{serviceModuleId: number;id: number;data?: UpdateCompanyAbsenceRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId>>, {serviceModuleId: number;id: number;data?: UpdateCompanyAbsenceRequest}> = (props) => {
          const {serviceModuleId,id,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId(serviceModuleId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId>>>
    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyIdMutationBody = UpdateCompanyAbsenceRequest | undefined
    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId>>, TError,{serviceModuleId: number;id: number;data?: UpdateCompanyAbsenceRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyId>>,
        TError,
        {serviceModuleId: number;id: number;data?: UpdateCompanyAbsenceRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesCompanyIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<AbsenceServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/absence/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId = (
    serviceModuleId: number,
    updateServiceModuleModel?: UpdateServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<AbsenceServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, {serviceModuleId: number;data?: UpdateServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdMutationBody = UpdateServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdMutationOptions(options), queryClient);
    }
    /**
 * Returns a report file of the absences and holidays of a given employee or a given set of employees.
 * The report can be of any of the file formats specified in its request body.
 */
export const postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports = (
    serviceModuleId: number,
    absenceReportRequest?: AbsenceReportRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/absences/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: absenceReportRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReportsMutationOptions = <TError = ErrorResponse | Blob,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports>>, TError,{serviceModuleId: number;data?: AbsenceReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports>>, TError,{serviceModuleId: number;data?: AbsenceReportRequest}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports>>, {serviceModuleId: number;data?: AbsenceReportRequest}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReportsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports>>>
    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReportsMutationBody = AbsenceReportRequest | undefined
    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReportsMutationError = ErrorResponse | Blob

    export const usePostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports = <TError = ErrorResponse | Blob,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports>>, TError,{serviceModuleId: number;data?: AbsenceReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReports>>,
        TError,
        {serviceModuleId: number;data?: AbsenceReportRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdAbsencesReportsMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<CalendarServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/calendars/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId = (
    serviceModuleId: number,
    updateCalendarServiceModuleModel?: UpdateCalendarServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<CalendarServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCalendarServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateCalendarServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateCalendarServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, {serviceModuleId: number;data?: UpdateCalendarServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdMutationBody = UpdateCalendarServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateCalendarServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateCalendarServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<(CalendarServiceModuleEventModel | SurveyAppointmentModuleSubtypeEventModel | CalendarServiceModuleAnniversaryEventModel | CalendarServiceModuleBirthdayEventModel | CalendarServiceModuleAbsenceEventModel)[]>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams,) => {
    return [
    `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>>
export type GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents = (
    serviceModuleId: number,
    createCalendarServiceModuleEventModel?: CreateCalendarServiceModuleEventModel,
 signal?: AbortSignal
) => {


      return axiosInstance<CalendarServiceModuleEventModel | SurveyAppointmentModuleSubtypeEventModel | CalendarServiceModuleAnniversaryEventModel | CalendarServiceModuleBirthdayEventModel | CalendarServiceModuleAbsenceEventModel>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCalendarServiceModuleEventModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError,{serviceModuleId: number;data?: CreateCalendarServiceModuleEventModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError,{serviceModuleId: number;data?: CreateCalendarServiceModuleEventModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, {serviceModuleId: number;data?: CreateCalendarServiceModuleEventModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>>
    export type PostApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsMutationBody = CreateCalendarServiceModuleEventModel | undefined
    export type PostApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>, TError,{serviceModuleId: number;data?: CreateCalendarServiceModuleEventModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEvents>>,
        TError,
        {serviceModuleId: number;data?: CreateCalendarServiceModuleEventModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId = (
    serviceModuleId: number,
    eventId: number,
    createCalendarServiceModuleEventModel?: CreateCalendarServiceModuleEventModel,
 signal?: AbortSignal
) => {


      return axiosInstance<CalendarServiceModuleEventModel | SurveyAppointmentModuleSubtypeEventModel | CalendarServiceModuleAnniversaryEventModel | CalendarServiceModuleBirthdayEventModel | CalendarServiceModuleAbsenceEventModel>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: createCalendarServiceModuleEventModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, TError,{serviceModuleId: number;eventId: number;data?: CreateCalendarServiceModuleEventModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, TError,{serviceModuleId: number;eventId: number;data?: CreateCalendarServiceModuleEventModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, {serviceModuleId: number;eventId: number;data?: CreateCalendarServiceModuleEventModel}> = (props) => {
          const {serviceModuleId,eventId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId(serviceModuleId,eventId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>>
    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationBody = CreateCalendarServiceModuleEventModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, TError,{serviceModuleId: number;eventId: number;data?: CreateCalendarServiceModuleEventModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>,
        TError,
        {serviceModuleId: number;eventId: number;data?: CreateCalendarServiceModuleEventModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId = (
    serviceModuleId: number,
    eventId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, TError,{serviceModuleId: number;eventId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, TError,{serviceModuleId: number;eventId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, {serviceModuleId: number;eventId: number}> = (props) => {
          const {serviceModuleId,eventId} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId(serviceModuleId,eventId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>>

    export type DeleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>, TError,{serviceModuleId: number;eventId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventId>>,
        TError,
        {serviceModuleId: number;eventId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon = (
    serviceModuleId: number,
    eventId: number,
    patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody?: PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody?.File !== undefined) {
 formData.append(`File`, patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody.File);
 }

      return axiosInstance<CalendarServiceModuleEventModel | SurveyAppointmentModuleSubtypeEventModel | CalendarServiceModuleAnniversaryEventModel | CalendarServiceModuleBirthdayEventModel | CalendarServiceModuleAbsenceEventModel>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}/icon`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon>>, TError,{serviceModuleId: number;eventId: number;data?: PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon>>, TError,{serviceModuleId: number;eventId: number;data?: PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon>>, {serviceModuleId: number;eventId: number;data?: PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody}> = (props) => {
          const {serviceModuleId,eventId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon(serviceModuleId,eventId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon>>>
    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconMutationBody = PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody | undefined
    export type PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon>>, TError,{serviceModuleId: number;eventId: number;data?: PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIcon>>,
        TError,
        {serviceModuleId: number;eventId: number;data?: PatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconBody},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdIconMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses = (
    serviceModuleId: number,
    eventId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<CalendarEventSurveyAnswer[]>(
      {url: `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}/surveyResponses`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponsesQueryKey = (serviceModuleId: number,
    eventId: number,) => {
    return [
    `/api/companies/current/servicemodules/calendars/${serviceModuleId}/events/${eventId}/surveyResponses`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponsesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError = ErrorResponse>(serviceModuleId: number,
    eventId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponsesQueryKey(serviceModuleId,eventId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses(serviceModuleId,eventId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined && eventId !== null && eventId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponsesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>>
export type GetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponsesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError = ErrorResponse>(
 serviceModuleId: number,
    eventId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError = ErrorResponse>(
 serviceModuleId: number,
    eventId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError = ErrorResponse>(
 serviceModuleId: number,
    eventId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError = ErrorResponse>(
 serviceModuleId: number,
    eventId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesCalendarsServiceModuleIdEventsEventIdSurveyResponsesQueryOptions(serviceModuleId,eventId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesFilesServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<FileServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/files/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/files/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesFilesServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesFilesServiceModuleId = (
    serviceModuleId: number,
    updateFileServiceModuleModel?: UpdateFileServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<FileServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/files/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFileServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesFilesServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateFileServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateFileServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesFilesServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, {serviceModuleId: number;data?: UpdateFileServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesFilesServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesFilesServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFilesServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesFilesServiceModuleIdMutationBody = UpdateFileServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesFilesServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesFilesServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFilesServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateFileServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFilesServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateFileServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesFilesServiceModuleIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile = (
    serviceModuleId: number,
    postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody?: PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody?.File !== undefined) {
 formData.append(`File`, postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody.File);
 }

      return axiosInstance<FileServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/files/${serviceModuleId}/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, TError,{serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, TError,{serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, {serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>>
    export type PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationBody = PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody | undefined
    export type PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationError = unknown

    export const usePostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, TError,{serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>,
        TError,
        {serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileBody},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<FileServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/files/${serviceModuleId}/file`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, TError,{serviceModuleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, TError,{serviceModuleId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, {serviceModuleId: number}> = (props) => {
          const {serviceModuleId} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile(serviceModuleId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>>

    export type DeleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationError = unknown

    export const useDeleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>, TError,{serviceModuleId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFile>>,
        TError,
        {serviceModuleId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesFilesServiceModuleIdFileMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt = (
    serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeServiceModuleEmployeeReadStateResponsePaginatedResponse>(
      {url: `/api/companies/current/servicemodules/files/${serviceModuleId}/read-receipt`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams,) => {
    return [
    `/api/companies/current/servicemodules/files/${serviceModuleId}/read-receipt`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError = unknown>(serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>>
export type GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptQueryError = unknown


export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError = unknown>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError = unknown>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError = unknown>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError = unknown>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceipt>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesFilesServiceModuleIdReadReceiptQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<(ServiceModuleModel | CalendarServiceModuleModel | FileServiceModuleModel | FolderServiceModuleModel | TextServiceModuleModel | UrlServiceModuleModel | LeaderboardServiceModuleModel | TimetrackingServiceModuleModel | AbsenceServiceModuleModel | PersonalDocumentsServiceModuleModel | StatusSystemServiceModuleModel | InsuranceServiceModuleModel)[]>(
      {url: `/api/companies/current/servicemodules/folders/${serviceModuleId}/children`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildrenQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/folders/${serviceModuleId}/children`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildrenQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildrenQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildrenQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>>
export type GetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildrenQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildren>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesFoldersServiceModuleIdChildrenQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId = (
    serviceModuleId: number,
    updateFolderServiceModuleModel?: UpdateFolderServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<FolderServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/folders/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateFolderServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesFoldersServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateFolderServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateFolderServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId>>, {serviceModuleId: number;data?: UpdateFolderServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesFoldersServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesFoldersServiceModuleIdMutationBody = UpdateFolderServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesFoldersServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesFoldersServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateFolderServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesFoldersServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateFolderServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesFoldersServiceModuleIdMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs = (
    serviceModuleId: number,
    healthInsuranceEmployeeConfigModel?: HealthInsuranceEmployeeConfigModel,
 signal?: AbortSignal
) => {


      return axiosInstance<HealthInsuranceEmployeeConfigModel>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}/employeeconfigs`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: healthInsuranceEmployeeConfigModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, {serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>>
    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationBody = HealthInsuranceEmployeeConfigModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>,
        TError,
        {serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs = (
    serviceModuleId: number,
    healthInsuranceEmployeeConfigModel?: HealthInsuranceEmployeeConfigModel,
 signal?: AbortSignal
) => {


      return axiosInstance<HealthInsuranceEmployeeConfigModel>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}/employeeconfigs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: healthInsuranceEmployeeConfigModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, {serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>>
    export type PostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationBody = HealthInsuranceEmployeeConfigModel | undefined
    export type PostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>,
        TError,
        {serviceModuleId: number;data?: HealthInsuranceEmployeeConfigModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs = (
    serviceModuleId: number,
    params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}/employeeconfigs`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, {serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams}> = (props) => {
          const {serviceModuleId,params} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs(serviceModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>>

    export type DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>, TError,{serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigs>>,
        TError,
        {serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension = (
    serviceModuleId: number,
    pensionInsuranceEmployeeConfigModel?: PensionInsuranceEmployeeConfigModel,
 signal?: AbortSignal
) => {


      return axiosInstance<PensionInsuranceEmployeeConfigModel>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}/employeeconfigs/pension`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: pensionInsuranceEmployeeConfigModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, {serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>>
    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationBody = PensionInsuranceEmployeeConfigModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>,
        TError,
        {serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension = (
    serviceModuleId: number,
    pensionInsuranceEmployeeConfigModel?: PensionInsuranceEmployeeConfigModel,
 signal?: AbortSignal
) => {


      return axiosInstance<PensionInsuranceEmployeeConfigModel>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}/employeeconfigs/pension`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pensionInsuranceEmployeeConfigModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, {serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>>
    export type PostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationBody = PensionInsuranceEmployeeConfigModel | undefined
    export type PostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>,
        TError,
        {serviceModuleId: number;data?: PensionInsuranceEmployeeConfigModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension = (
    serviceModuleId: number,
    params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}/employeeconfigs/pension`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, {serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams}> = (props) => {
          const {serviceModuleId,params} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension(serviceModuleId,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>>

    export type DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>, TError,{serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPension>>,
        TError,
        {serviceModuleId: number;params?: DeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdEmployeeconfigsPensionMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<InsuranceServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/insurance/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId = (
    serviceModuleId: number,
    updateInsuranceServiceModuleModel?: UpdateInsuranceServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<InsuranceServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/insurance/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateInsuranceServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateInsuranceServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateInsuranceServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, {serviceModuleId: number;data?: UpdateInsuranceServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdMutationBody = UpdateInsuranceServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateInsuranceServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesInsuranceServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateInsuranceServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesInsuranceServiceModuleIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<LeaderboardServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId = (
    serviceModuleId: number,
    updateLeaderboardServiceModuleModel?: UpdateLeaderboardServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<TextServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateLeaderboardServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateLeaderboardServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateLeaderboardServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, {serviceModuleId: number;data?: UpdateLeaderboardServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdMutationBody = UpdateLeaderboardServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateLeaderboardServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateLeaderboardServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LeaderboardUserRankModel[]>(
      {url: `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}/dashboard`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams,) => {
    return [
    `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}/dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>>
export type GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdDashboardQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard = (
    serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LeaderboardUserRankModelPaginatedResponse>(
      {url: `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}/board`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams,) => {
    return [
    `/api/companies/current/servicemodules/leaderboards/${serviceModuleId}/board`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError = ErrorResponse>(serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>>
export type GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoard>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesLeaderboardsServiceModuleIdBoardQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesLeaderboardsActionModules = (
    params?: GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse[]>(
      {url: `/api/companies/current/servicemodules/leaderboards/actionModules`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesQueryKey = (params?: GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams,) => {
    return [
    `/api/companies/current/servicemodules/leaderboards/actionModules`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError = ErrorResponse>(params?: GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesLeaderboardsActionModules(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>>
export type GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesLeaderboardsActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesLeaderboardsActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesLeaderboardsActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesLeaderboardsActionModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesLeaderboardsActionModulesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId = (
    serviceModuleId: number,
    updatePersonalDocumentsServiceModuleRequest?: UpdatePersonalDocumentsServiceModuleRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<PersonalDocumentsServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePersonalDocumentsServiceModuleRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdatePersonalDocumentsServiceModuleRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdatePersonalDocumentsServiceModuleRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId>>, {serviceModuleId: number;data?: UpdatePersonalDocumentsServiceModuleRequest}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdMutationBody = UpdatePersonalDocumentsServiceModuleRequest | undefined
    export type PatchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdatePersonalDocumentsServiceModuleRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdatePersonalDocumentsServiceModuleRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest = (
    serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams,
 signal?: AbortSignal
) => {


      return axiosInstance<LatestPersonalDocumentResponse[]>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/latest`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams,) => {
    return [
    `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/latest`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError = ErrorResponse>(serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>>
export type GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: undefined |  GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatest>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdLatestQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<PersonalDocumentEmployeeResponse[]>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/employees`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeesQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/employees`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeesQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>>
export type GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeesQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId = (
    serviceModuleId: number,
    employeeUserId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<PersonalDocumentResponse[]>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/employee/${employeeUserId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdQueryKey = (serviceModuleId: number,
    employeeUserId: string,) => {
    return [
    `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/employee/${employeeUserId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError = ErrorResponse>(serviceModuleId: number,
    employeeUserId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdQueryKey(serviceModuleId,employeeUserId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId(serviceModuleId,employeeUserId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined && employeeUserId !== null && employeeUserId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>>
export type GetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    employeeUserId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    employeeUserId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    employeeUserId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError = ErrorResponse>(
 serviceModuleId: number,
    employeeUserId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdQueryOptions(serviceModuleId,employeeUserId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile = (
    serviceModuleId: number,
    employeeUserId: string,
    postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody?.File !== undefined) {
 formData.append(`File`, postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody.File);
 }

      return axiosInstance<PersonalDocumentResponse>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/employee/${employeeUserId}/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile>>, TError,{serviceModuleId: number;employeeUserId: string;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile>>, TError,{serviceModuleId: number;employeeUserId: string;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile>>, {serviceModuleId: number;employeeUserId: string;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody}> = (props) => {
          const {serviceModuleId,employeeUserId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile(serviceModuleId,employeeUserId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile>>>
    export type PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileMutationBody = PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody | undefined
    export type PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile>>, TError,{serviceModuleId: number;employeeUserId: string;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFile>>,
        TError,
        {serviceModuleId: number;employeeUserId: string;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileBody},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile = (
    serviceModuleId: number,
    postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody?.File !== undefined) {
 formData.append(`File`, postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody.File);
 }

      return axiosInstance<PersonalDocumentResponse>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/file`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile>>, TError,{serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile>>, TError,{serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile>>, {serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile>>>
    export type PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileMutationBody = PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody | undefined
    export type PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile>>, TError,{serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFile>>,
        TError,
        {serviceModuleId: number;data?: PostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileBody},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdFileMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId = (
    serviceModuleId: number,
    employeeUserId: string,
    documentId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/personaldocuments/${serviceModuleId}/employee/${employeeUserId}/file/${documentId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId>>, TError,{serviceModuleId: number;employeeUserId: string;documentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId>>, TError,{serviceModuleId: number;employeeUserId: string;documentId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId>>, {serviceModuleId: number;employeeUserId: string;documentId: string}> = (props) => {
          const {serviceModuleId,employeeUserId,documentId} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId(serviceModuleId,employeeUserId,documentId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId>>>

    export type DeleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId>>, TError,{serviceModuleId: number;employeeUserId: string;documentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentId>>,
        TError,
        {serviceModuleId: number;employeeUserId: string;documentId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesPersonaldocumentsServiceModuleIdEmployeeEmployeeUserIdFileDocumentIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<StatusSystemServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/statussystem/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/statussystem/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId = (
    serviceModuleId: number,
    updateStatusSystemServiceModuleModel?: UpdateStatusSystemServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<StatusSystemServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/statussystem/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateStatusSystemServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateStatusSystemServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateStatusSystemServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, {serviceModuleId: number;data?: UpdateStatusSystemServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdMutationBody = UpdateStatusSystemServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateStatusSystemServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesStatussystemServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateStatusSystemServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels = (
    serviceModuleId: number,
    createStatusLevelModel?: CreateStatusLevelModel,
 signal?: AbortSignal
) => {


      return axiosInstance<StatusLevelModel>(
      {url: `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/levels`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createStatusLevelModel, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels>>, TError,{serviceModuleId: number;data?: CreateStatusLevelModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels>>, TError,{serviceModuleId: number;data?: CreateStatusLevelModel}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels>>, {serviceModuleId: number;data?: CreateStatusLevelModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels>>>
    export type PostApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsMutationBody = CreateStatusLevelModel | undefined
    export type PostApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels>>, TError,{serviceModuleId: number;data?: CreateStatusLevelModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevels>>,
        TError,
        {serviceModuleId: number;data?: CreateStatusLevelModel},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsMutationOptions(options), queryClient);
    }
    export const putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId = (
    serviceModuleId: number,
    statusLevelId: string,
    updateStatusLevelModel?: UpdateStatusLevelModel,
 signal?: AbortSignal
) => {


      return axiosInstance<StatusLevelModel>(
      {url: `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/levels/${statusLevelId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateStatusLevelModel, signal
    },
      );
    }




export const getPutApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, TError,{serviceModuleId: number;statusLevelId: string;data?: UpdateStatusLevelModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, TError,{serviceModuleId: number;statusLevelId: string;data?: UpdateStatusLevelModel}, TContext> => {

const mutationKey = ['putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, {serviceModuleId: number;statusLevelId: string;data?: UpdateStatusLevelModel}> = (props) => {
          const {serviceModuleId,statusLevelId,data} = props ?? {};

          return  putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId(serviceModuleId,statusLevelId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>>
    export type PutApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationBody = UpdateStatusLevelModel | undefined
    export type PutApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationError = ErrorResponse

    export const usePutApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, TError,{serviceModuleId: number;statusLevelId: string;data?: UpdateStatusLevelModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>,
        TError,
        {serviceModuleId: number;statusLevelId: string;data?: UpdateStatusLevelModel},
        TContext
      > => {
      return useMutation(getPutApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId = (
    serviceModuleId: number,
    statusLevelId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/statussystem/${serviceModuleId}/levels/${statusLevelId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, TError,{serviceModuleId: number;statusLevelId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, TError,{serviceModuleId: number;statusLevelId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, {serviceModuleId: number;statusLevelId: string}> = (props) => {
          const {serviceModuleId,statusLevelId} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId(serviceModuleId,statusLevelId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>>

    export type DeleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>, TError,{serviceModuleId: number;statusLevelId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelId>>,
        TError,
        {serviceModuleId: number;statusLevelId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesStatussystemServiceModuleIdLevelsStatusLevelIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesTextsServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<TextServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/texts/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTextsServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/texts/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTextsServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTextsServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTextsServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTextsServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesTextsServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTextsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTextsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTextsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTextsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTextsServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesTextsServiceModuleId = (
    serviceModuleId: number,
    updateTextServiceModuleModel?: UpdateTextServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<TextServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/texts/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTextServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesTextsServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateTextServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateTextServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesTextsServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, {serviceModuleId: number;data?: UpdateTextServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesTextsServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesTextsServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTextsServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesTextsServiceModuleIdMutationBody = UpdateTextServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesTextsServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesTextsServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTextsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateTextServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTextsServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateTextServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesTextsServiceModuleIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota = (
    serviceModuleId: number,
    createTimeQuotaRequest?: CreateTimeQuotaRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTimeQuotaRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError,{serviceModuleId: number;data?: CreateTimeQuotaRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError,{serviceModuleId: number;data?: CreateTimeQuotaRequest}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, {serviceModuleId: number;data?: CreateTimeQuotaRequest}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>>
    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationBody = CreateTimeQuotaRequest | undefined
    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError,{serviceModuleId: number;data?: CreateTimeQuotaRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>,
        TError,
        {serviceModuleId: number;data?: CreateTimeQuotaRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota = (
    serviceModuleId: number,
    updateTimeQuotaRequest?: UpdateTimeQuotaRequest,
    params?: PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimeQuotaModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTimeQuotaRequest,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError,{serviceModuleId: number;data?: UpdateTimeQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError,{serviceModuleId: number;data?: UpdateTimeQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, {serviceModuleId: number;data?: UpdateTimeQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams}> = (props) => {
          const {serviceModuleId,data,params} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota(serviceModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>>
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationBody = UpdateTimeQuotaRequest | undefined
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>, TError,{serviceModuleId: number;data?: UpdateTimeQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequota>>,
        TError,
        {serviceModuleId: number;data?: UpdateTimeQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId = (
    serviceModuleId: number,
    id: number,
    params?: DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timequota/${id}`, method: 'DELETE',
        params, signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId>>, TError,{serviceModuleId: number;id: number;params?: DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId>>, TError,{serviceModuleId: number;id: number;params?: DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId>>, {serviceModuleId: number;id: number;params?: DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams}> = (props) => {
          const {serviceModuleId,id,params} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId(serviceModuleId,id,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId>>>

    export type DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId>>, TError,{serviceModuleId: number;id: number;params?: DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaId>>,
        TError,
        {serviceModuleId: number;id: number;params?: DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdParams},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimequotaIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany = (
    serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams,
 signal?: AbortSignal
) => {


      return axiosInstance<TimesheetModelPaginatedResponse>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timetracking/company`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyQueryKey = (serviceModuleId: number,
    params?: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timetracking/company`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError = ErrorResponse>(serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyQueryKey(serviceModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany(serviceModuleId,params, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError = ErrorResponse>(
 serviceModuleId: number,
    params: GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompany>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingCompanyQueryOptions(serviceModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId = (
    serviceModuleId: number,
    id: number,
    updateTimesheetCompanyRequest?: UpdateTimesheetCompanyRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<TimesheetModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timetracking/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTimesheetCompanyRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId>>, TError,{serviceModuleId: number;id: number;data?: UpdateTimesheetCompanyRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId>>, TError,{serviceModuleId: number;id: number;data?: UpdateTimesheetCompanyRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId>>, {serviceModuleId: number;id: number;data?: UpdateTimesheetCompanyRequest}> = (props) => {
          const {serviceModuleId,id,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId(serviceModuleId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId>>>
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingIdMutationBody = UpdateTimesheetCompanyRequest | undefined
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId>>, TError,{serviceModuleId: number;id: number;data?: UpdateTimesheetCompanyRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingId>>,
        TError,
        {serviceModuleId: number;id: number;data?: UpdateTimesheetCompanyRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects = (
    serviceModuleId: number,
    createProjectRequest?: CreateProjectRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<ProjectModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createProjectRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError,{serviceModuleId: number;data?: CreateProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError,{serviceModuleId: number;data?: CreateProjectRequest}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, {serviceModuleId: number;data?: CreateProjectRequest}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>>
    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsMutationBody = CreateProjectRequest | undefined
    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>, TError,{serviceModuleId: number;data?: CreateProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjects>>,
        TError,
        {serviceModuleId: number;data?: CreateProjectRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId = (
    serviceModuleId: number,
    id: number,
    updateProjectRequest?: UpdateProjectRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<ProjectModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/projects/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateProjectRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, TError,{serviceModuleId: number;id: number;data?: UpdateProjectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, TError,{serviceModuleId: number;id: number;data?: UpdateProjectRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, {serviceModuleId: number;id: number;data?: UpdateProjectRequest}> = (props) => {
          const {serviceModuleId,id,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId(serviceModuleId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>>
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationBody = UpdateProjectRequest | undefined
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, TError,{serviceModuleId: number;id: number;data?: UpdateProjectRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>,
        TError,
        {serviceModuleId: number;id: number;data?: UpdateProjectRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId = (
    serviceModuleId: number,
    id: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/projects/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, TError,{serviceModuleId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, TError,{serviceModuleId: number;id: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, {serviceModuleId: number;id: number}> = (props) => {
          const {serviceModuleId,id} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId(serviceModuleId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>>

    export type DeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>, TError,{serviceModuleId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsId>>,
        TError,
        {serviceModuleId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdProjectsIdMutationOptions(options), queryClient);
    }
    /**
 * Returns a report file of the working hours of a given employee or a given set of employees.
 * The report can be of any of the file formats specified in its request body.
 */
export const postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports = (
    serviceModuleId: number,
    timeTrackingReportRequest?: TimeTrackingReportRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}/timetracking/reports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: timeTrackingReportRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReportsMutationOptions = <TError = ErrorResponse | Blob,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports>>, TError,{serviceModuleId: number;data?: TimeTrackingReportRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports>>, TError,{serviceModuleId: number;data?: TimeTrackingReportRequest}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports>>, {serviceModuleId: number;data?: TimeTrackingReportRequest}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReportsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports>>>
    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReportsMutationBody = TimeTrackingReportRequest | undefined
    export type PostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReportsMutationError = ErrorResponse | Blob

    export const usePostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports = <TError = ErrorResponse | Blob,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports>>, TError,{serviceModuleId: number;data?: TimeTrackingReportRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReports>>,
        TError,
        {serviceModuleId: number;data?: TimeTrackingReportRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdTimetrackingReportsMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<TimetrackingServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/timetracking/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId = (
    serviceModuleId: number,
    updateTimetrackingServiceModuleModel?: UpdateTimetrackingServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<TimetrackingServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/timetracking/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTimetrackingServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateTimetrackingServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateTimetrackingServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, {serviceModuleId: number;data?: UpdateTimetrackingServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdMutationBody = UpdateTimetrackingServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateTimetrackingServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateTimetrackingServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesTimetrackingServiceModuleIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentServicemodulesUrlsServiceModuleId = (
    serviceModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<UrlServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/urls/${serviceModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentServicemodulesUrlsServiceModuleIdQueryKey = (serviceModuleId: number,) => {
    return [
    `/api/companies/current/servicemodules/urls/${serviceModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentServicemodulesUrlsServiceModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError = ErrorResponse>(serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentServicemodulesUrlsServiceModuleIdQueryKey(serviceModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>> = ({ signal }) => getApiCompaniesCurrentServicemodulesUrlsServiceModuleId(serviceModuleId, signal);





   return  { queryKey, queryFn, enabled: serviceModuleId !== null && serviceModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentServicemodulesUrlsServiceModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>>
export type GetApiCompaniesCurrentServicemodulesUrlsServiceModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentServicemodulesUrlsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesUrlsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentServicemodulesUrlsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentServicemodulesUrlsServiceModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError = ErrorResponse>(
 serviceModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentServicemodulesUrlsServiceModuleIdQueryOptions(serviceModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId = (
    serviceModuleId: number,
    updateUrlServiceModuleModel?: UpdateUrlServiceModuleModel,
 signal?: AbortSignal
) => {


      return axiosInstance<UrlServiceModuleModel>(
      {url: `/api/companies/current/servicemodules/urls/${serviceModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUrlServiceModuleModel, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesUrlsServiceModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateUrlServiceModuleModel}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateUrlServiceModuleModel}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, {serviceModuleId: number;data?: UpdateUrlServiceModuleModel}> = (props) => {
          const {serviceModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId(serviceModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesUrlsServiceModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>>
    export type PatchApiCompaniesCurrentServicemodulesUrlsServiceModuleIdMutationBody = UpdateUrlServiceModuleModel | undefined
    export type PatchApiCompaniesCurrentServicemodulesUrlsServiceModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesUrlsServiceModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>, TError,{serviceModuleId: number;data?: UpdateUrlServiceModuleModel}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesUrlsServiceModuleId>>,
        TError,
        {serviceModuleId: number;data?: UpdateUrlServiceModuleModel},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesUrlsServiceModuleIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota = (
    serviceModuleId: number,
    createVacationQuotaRequest?: CreateVacationQuotaRequest,
    params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VacationQuotaModel>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createVacationQuotaRequest,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError,{serviceModuleId: number;data?: CreateVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError,{serviceModuleId: number;data?: CreateVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, {serviceModuleId: number;data?: CreateVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}> = (props) => {
          const {serviceModuleId,data,params} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota(serviceModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>>
    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationBody = CreateVacationQuotaRequest | undefined
    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError,{serviceModuleId: number;data?: CreateVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>,
        TError,
        {serviceModuleId: number;data?: CreateVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota = (
    serviceModuleId: number,
    updateVacationQuotaRequest?: UpdateVacationQuotaRequest,
    params?: PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VacationQuotaModel>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateVacationQuotaRequest,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError,{serviceModuleId: number;data?: UpdateVacationQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError,{serviceModuleId: number;data?: UpdateVacationQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, {serviceModuleId: number;data?: UpdateVacationQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}> = (props) => {
          const {serviceModuleId,data,params} = props ?? {};

          return  patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota(serviceModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>>
    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationBody = UpdateVacationQuotaRequest | undefined
    export type PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>, TError,{serviceModuleId: number;data?: UpdateVacationQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquota>>,
        TError,
        {serviceModuleId: number;data?: UpdateVacationQuotaRequest;params?: PatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId = (
    serviceModuleId: number,
    vacationQuotaId: number,
    finishVacationQuotaRequest?: FinishVacationQuotaRequest,
    params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<VacationQuotaModel>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota/finish/${vacationQuotaId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: finishVacationQuotaRequest,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId>>, TError,{serviceModuleId: number;vacationQuotaId: number;data?: FinishVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId>>, TError,{serviceModuleId: number;vacationQuotaId: number;data?: FinishVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId>>, {serviceModuleId: number;vacationQuotaId: number;data?: FinishVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams}> = (props) => {
          const {serviceModuleId,vacationQuotaId,data,params} = props ?? {};

          return  postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId(serviceModuleId,vacationQuotaId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId>>>
    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdMutationBody = FinishVacationQuotaRequest | undefined
    export type PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId>>, TError,{serviceModuleId: number;vacationQuotaId: number;data?: FinishVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaId>>,
        TError,
        {serviceModuleId: number;vacationQuotaId: number;data?: FinishVacationQuotaRequest;params?: PostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaFinishVacationQuotaIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId = (
    serviceModuleId: number,
    id: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/servicemodules/absence/${serviceModuleId}/vacationquota/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId>>, TError,{serviceModuleId: number;id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId>>, TError,{serviceModuleId: number;id: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId>>, {serviceModuleId: number;id: number}> = (props) => {
          const {serviceModuleId,id} = props ?? {};

          return  deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId(serviceModuleId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId>>>

    export type DeleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId>>, TError,{serviceModuleId: number;id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaId>>,
        TError,
        {serviceModuleId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentServicemodulesAbsenceServiceModuleIdVacationquotaIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentNotifications = (
    params: GetApiCompaniesCurrentNotificationsParams,
 signal?: AbortSignal
) => {


      return axiosInstance<GenericInAppNotificationDefinitionResponsePaginatedResponse>(
      {url: `/api/companies/current/notifications`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentNotificationsQueryKey = (params?: GetApiCompaniesCurrentNotificationsParams,) => {
    return [
    `/api/companies/current/notifications`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError = ErrorResponse>(params: GetApiCompaniesCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentNotificationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>> = ({ signal }) => getApiCompaniesCurrentNotifications(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>>
export type GetApiCompaniesCurrentNotificationsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentNotifications<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentNotifications<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentNotifications<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentNotifications<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError = ErrorResponse>(
 params: GetApiCompaniesCurrentNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentNotifications = (
    genericInAppNotificationDefinitionRequest?: GenericInAppNotificationDefinitionRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<number>(
      {url: `/api/companies/current/notifications`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: genericInAppNotificationDefinitionRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentNotificationsMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentNotifications>>, TError,{data?: GenericInAppNotificationDefinitionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentNotifications>>, TError,{data?: GenericInAppNotificationDefinitionRequest}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentNotifications'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentNotifications>>, {data?: GenericInAppNotificationDefinitionRequest}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesCurrentNotifications(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentNotificationsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentNotifications>>>
    export type PostApiCompaniesCurrentNotificationsMutationBody = GenericInAppNotificationDefinitionRequest | undefined
    export type PostApiCompaniesCurrentNotificationsMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentNotifications = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentNotifications>>, TError,{data?: GenericInAppNotificationDefinitionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentNotifications>>,
        TError,
        {data?: GenericInAppNotificationDefinitionRequest},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentNotificationsMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentNotificationsId = (
    id: number,
 signal?: AbortSignal
) => {


      return axiosInstance<GenericInAppNotificationDefinitionResponse>(
      {url: `/api/companies/current/notifications/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentNotificationsIdQueryKey = (id: number,) => {
    return [
    `/api/companies/current/notifications/${id}`
    ] as const;
    }


export const getGetApiCompaniesCurrentNotificationsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError = ErrorResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentNotificationsIdQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>> = ({ signal }) => getApiCompaniesCurrentNotificationsId(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentNotificationsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>>
export type GetApiCompaniesCurrentNotificationsIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentNotificationsId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError = ErrorResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentNotificationsId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentNotificationsId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentNotificationsId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentNotificationsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentNotificationsId = (
    id: number,
    genericInAppNotificationDefinitionRequest?: GenericInAppNotificationDefinitionRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/notifications/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: genericInAppNotificationDefinitionRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentNotificationsIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentNotificationsId>>, TError,{id: number;data?: GenericInAppNotificationDefinitionRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentNotificationsId>>, TError,{id: number;data?: GenericInAppNotificationDefinitionRequest}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentNotificationsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentNotificationsId>>, {id: number;data?: GenericInAppNotificationDefinitionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiCompaniesCurrentNotificationsId(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentNotificationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentNotificationsId>>>
    export type PatchApiCompaniesCurrentNotificationsIdMutationBody = GenericInAppNotificationDefinitionRequest | undefined
    export type PatchApiCompaniesCurrentNotificationsIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentNotificationsId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentNotificationsId>>, TError,{id: number;data?: GenericInAppNotificationDefinitionRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentNotificationsId>>,
        TError,
        {id: number;data?: GenericInAppNotificationDefinitionRequest},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentNotificationsIdMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentNotificationsId = (
    id: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/notifications/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentNotificationsIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsId>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentNotificationsId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiCompaniesCurrentNotificationsId(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentNotificationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsId>>>

    export type DeleteApiCompaniesCurrentNotificationsIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentNotificationsId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsId>>, TError,{id: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentNotificationsIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentNotificationsIdDetails = (
    id: number,
 signal?: AbortSignal
) => {


      return axiosInstance<GenericInAppNotificationDefinitionDetailResponse>(
      {url: `/api/companies/current/notifications/${id}/details`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentNotificationsIdDetailsQueryKey = (id: number,) => {
    return [
    `/api/companies/current/notifications/${id}/details`
    ] as const;
    }


export const getGetApiCompaniesCurrentNotificationsIdDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError = ErrorResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentNotificationsIdDetailsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>> = ({ signal }) => getApiCompaniesCurrentNotificationsIdDetails(id, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentNotificationsIdDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>>
export type GetApiCompaniesCurrentNotificationsIdDetailsQueryError = ErrorResponse


export function useGetApiCompaniesCurrentNotificationsIdDetails<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError = ErrorResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentNotificationsIdDetails<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentNotificationsIdDetails<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentNotificationsIdDetails<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentNotificationsIdDetails>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentNotificationsIdDetailsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentNotificationsIdImage = (
    id: number,
    postApiCompaniesCurrentNotificationsIdImageBody?: PostApiCompaniesCurrentNotificationsIdImageBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(postApiCompaniesCurrentNotificationsIdImageBody?.File !== undefined) {
 formData.append(`File`, postApiCompaniesCurrentNotificationsIdImageBody.File);
 }

      return axiosInstance<string>(
      {url: `/api/companies/current/notifications/${id}/image`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPostApiCompaniesCurrentNotificationsIdImageMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentNotificationsIdImage>>, TError,{id: number;data?: PostApiCompaniesCurrentNotificationsIdImageBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentNotificationsIdImage>>, TError,{id: number;data?: PostApiCompaniesCurrentNotificationsIdImageBody}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentNotificationsIdImage'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentNotificationsIdImage>>, {id: number;data?: PostApiCompaniesCurrentNotificationsIdImageBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postApiCompaniesCurrentNotificationsIdImage(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentNotificationsIdImageMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentNotificationsIdImage>>>
    export type PostApiCompaniesCurrentNotificationsIdImageMutationBody = PostApiCompaniesCurrentNotificationsIdImageBody | undefined
    export type PostApiCompaniesCurrentNotificationsIdImageMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentNotificationsIdImage = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentNotificationsIdImage>>, TError,{id: number;data?: PostApiCompaniesCurrentNotificationsIdImageBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentNotificationsIdImage>>,
        TError,
        {id: number;data?: PostApiCompaniesCurrentNotificationsIdImageBody},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentNotificationsIdImageMutationOptions(options), queryClient);
    }
    export const deleteApiCompaniesCurrentNotificationsIdImageImageId = (
    id: number,
    imageId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/notifications/${id}/image/${imageId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentNotificationsIdImageImageIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsIdImageImageId>>, TError,{id: number;imageId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsIdImageImageId>>, TError,{id: number;imageId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentNotificationsIdImageImageId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsIdImageImageId>>, {id: number;imageId: string}> = (props) => {
          const {id,imageId} = props ?? {};

          return  deleteApiCompaniesCurrentNotificationsIdImageImageId(id,imageId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentNotificationsIdImageImageIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsIdImageImageId>>>

    export type DeleteApiCompaniesCurrentNotificationsIdImageImageIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentNotificationsIdImageImageId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsIdImageImageId>>, TError,{id: number;imageId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentNotificationsIdImageImageId>>,
        TError,
        {id: number;imageId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentNotificationsIdImageImageIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty = (
    entityType: LocalizationEntityType,
    entityId: string,
    property: string,
 signal?: AbortSignal
) => {


      return axiosInstance<GetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty200One | GetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty200Two>(
      {url: `/api/companies/current/translations/${entityType}/${entityId}/${property}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyQueryKey = (entityType: LocalizationEntityType,
    entityId: string,
    property: string,) => {
    return [
    `/api/companies/current/translations/${entityType}/${entityId}/${property}`
    ] as const;
    }


export const getGetApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError = ErrorResponse>(entityType: LocalizationEntityType,
    entityId: string,
    property: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyQueryKey(entityType,entityId,property);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>> = ({ signal }) => getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty(entityType,entityId,property, signal);





   return  { queryKey, queryFn, enabled: entityType !== null && entityType !== undefined && entityId !== null && entityId !== undefined && property !== null && property !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>>
export type GetApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyQueryError = ErrorResponse


export function useGetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError = ErrorResponse>(
 entityType: LocalizationEntityType,
    entityId: string,
    property: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError = ErrorResponse>(
 entityType: LocalizationEntityType,
    entityId: string,
    property: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError = ErrorResponse>(
 entityType: LocalizationEntityType,
    entityId: string,
    property: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError = ErrorResponse>(
 entityType: LocalizationEntityType,
    entityId: string,
    property: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyQueryOptions(entityType,entityId,property,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty = (
    entityType: LocalizationEntityType,
    entityId: string,
    property: string,
    patchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBody?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree,
    params?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/translations/${entityType}/${entityId}/${property}`, method: 'PATCH',
      data: patchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBody,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError,{entityType: LocalizationEntityType;entityId: string;property: string;data?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree;params?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError,{entityType: LocalizationEntityType;entityId: string;property: string;data?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree;params?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, {entityType: LocalizationEntityType;entityId: string;property: string;data?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree;params?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams}> = (props) => {
          const {entityType,entityId,property,data,params} = props ?? {};

          return  patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty(entityType,entityId,property,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>>
    export type PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyMutationBody = PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree | undefined
    export type PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>, TError,{entityType: LocalizationEntityType;entityId: string;property: string;data?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree;params?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentTranslationsEntityTypeEntityIdProperty>>,
        TError,
        {entityType: LocalizationEntityType;entityId: string;property: string;data?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyOne | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyTwo | PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyBodyThree;params?: PatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentTranslationsEntityTypeEntityIdPropertyMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentEmployees = (

 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserResponse[]>(
      {url: `/api/companies/current/employees`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesQueryKey = () => {
    return [
    `/api/companies/current/employees`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>> = ({ signal }) => getApiCompaniesCurrentEmployees(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>>
export type GetApiCompaniesCurrentEmployeesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentEmployees = (
    createEmployeeRequest?: CreateEmployeeRequest[],
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createEmployeeRequest, signal
    },
      );
    }




export const getPostApiCompaniesCurrentEmployeesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployees>>, TError,{data?: CreateEmployeeRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployees>>, TError,{data?: CreateEmployeeRequest[]}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentEmployees'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployees>>, {data?: CreateEmployeeRequest[]}> = (props) => {
          const {data} = props ?? {};

          return  postApiCompaniesCurrentEmployees(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentEmployeesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployees>>>
    export type PostApiCompaniesCurrentEmployeesMutationBody = CreateEmployeeRequest[] | undefined
    export type PostApiCompaniesCurrentEmployeesMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentEmployees = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployees>>, TError,{data?: CreateEmployeeRequest[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentEmployees>>,
        TError,
        {data?: CreateEmployeeRequest[]},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentEmployeesMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentEmployeesEmployeeId = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<EmployeeUserDetailedResponse>(
      {url: `/api/companies/current/employees/${employeeId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesEmployeeIdQueryKey = (employeeId: string,) => {
    return [
    `/api/companies/current/employees/${employeeId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesEmployeeIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError = ErrorResponse>(employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesEmployeeIdQueryKey(employeeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>> = ({ signal }) => getApiCompaniesCurrentEmployeesEmployeeId(employeeId, signal);





   return  { queryKey, queryFn, enabled: employeeId !== null && employeeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesEmployeeIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>>
export type GetApiCompaniesCurrentEmployeesEmployeeIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesEmployeeId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError = ErrorResponse>(
 employeeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesEmployeeId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesEmployeeIdQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deleteApiCompaniesCurrentEmployeesEmployeeId = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<number>(
      {url: `/api/companies/current/employees/${employeeId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentEmployeesEmployeeIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeId>>, TError,{employeeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeId>>, TError,{employeeId: string}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentEmployeesEmployeeId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeId>>, {employeeId: string}> = (props) => {
          const {employeeId} = props ?? {};

          return  deleteApiCompaniesCurrentEmployeesEmployeeId(employeeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentEmployeesEmployeeIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeId>>>

    export type DeleteApiCompaniesCurrentEmployeesEmployeeIdMutationError = ErrorResponse

    export const useDeleteApiCompaniesCurrentEmployeesEmployeeId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeId>>, TError,{employeeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentEmployeesEmployeeId>>,
        TError,
        {employeeId: string},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentEmployeesEmployeeIdMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees/${employeeId}/transactions/book`, method: 'POST', signal
    },
      );
    }




export const getPostApiCompaniesCurrentEmployeesEmployeeIdTransactionsBookMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook>>, TError,{employeeId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook>>, TError,{employeeId: string}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook>>, {employeeId: string}> = (props) => {
          const {employeeId} = props ?? {};

          return  postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook(employeeId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentEmployeesEmployeeIdTransactionsBookMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook>>>

    export type PostApiCompaniesCurrentEmployeesEmployeeIdTransactionsBookMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook>>, TError,{employeeId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentEmployeesEmployeeIdTransactionsBook>>,
        TError,
        {employeeId: string},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentEmployeesEmployeeIdTransactionsBookMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentEmployeesEmployeeIdShopModules = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<number[]>(
      {url: `/api/companies/current/employees/${employeeId}/shopModules`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesEmployeeIdShopModulesQueryKey = (employeeId: string,) => {
    return [
    `/api/companies/current/employees/${employeeId}/shopModules`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesEmployeeIdShopModulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError = ErrorResponse>(employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesEmployeeIdShopModulesQueryKey(employeeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>> = ({ signal }) => getApiCompaniesCurrentEmployeesEmployeeIdShopModules(employeeId, signal);





   return  { queryKey, queryFn, enabled: employeeId !== null && employeeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesEmployeeIdShopModulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>>
export type GetApiCompaniesCurrentEmployeesEmployeeIdShopModulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesEmployeeIdShopModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError = ErrorResponse>(
 employeeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeIdShopModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeIdShopModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesEmployeeIdShopModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesEmployeeIdShopModulesQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentEmployeesEmployeeIdShopModules = (
    employeeId: string,
    patchApiCompaniesCurrentEmployeesEmployeeIdShopModulesBody?: number[],
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees/${employeeId}/shopModules`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiCompaniesCurrentEmployeesEmployeeIdShopModulesBody, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentEmployeesEmployeeIdShopModulesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError,{employeeId: string;data?: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError,{employeeId: string;data?: number[]}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentEmployeesEmployeeIdShopModules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, {employeeId: string;data?: number[]}> = (props) => {
          const {employeeId,data} = props ?? {};

          return  patchApiCompaniesCurrentEmployeesEmployeeIdShopModules(employeeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentEmployeesEmployeeIdShopModulesMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdShopModules>>>
    export type PatchApiCompaniesCurrentEmployeesEmployeeIdShopModulesMutationBody = number[] | undefined
    export type PatchApiCompaniesCurrentEmployeesEmployeeIdShopModulesMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentEmployeesEmployeeIdShopModules = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdShopModules>>, TError,{employeeId: string;data?: number[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdShopModules>>,
        TError,
        {employeeId: string;data?: number[]},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentEmployeesEmployeeIdShopModulesMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentEmployeesEmployeeIdActionModules = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<number[]>(
      {url: `/api/companies/current/employees/${employeeId}/actionModules`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesEmployeeIdActionModulesQueryKey = (employeeId: string,) => {
    return [
    `/api/companies/current/employees/${employeeId}/actionModules`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesEmployeeIdActionModulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError = ErrorResponse>(employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesEmployeeIdActionModulesQueryKey(employeeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>> = ({ signal }) => getApiCompaniesCurrentEmployeesEmployeeIdActionModules(employeeId, signal);





   return  { queryKey, queryFn, enabled: employeeId !== null && employeeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesEmployeeIdActionModulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>>
export type GetApiCompaniesCurrentEmployeesEmployeeIdActionModulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesEmployeeIdActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError = ErrorResponse>(
 employeeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeIdActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeIdActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesEmployeeIdActionModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesEmployeeIdActionModulesQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentEmployeesEmployeeIdActionModules = (
    employeeId: string,
    patchApiCompaniesCurrentEmployeesEmployeeIdActionModulesBody?: number[],
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees/${employeeId}/actionModules`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiCompaniesCurrentEmployeesEmployeeIdActionModulesBody, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentEmployeesEmployeeIdActionModulesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError,{employeeId: string;data?: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError,{employeeId: string;data?: number[]}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentEmployeesEmployeeIdActionModules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, {employeeId: string;data?: number[]}> = (props) => {
          const {employeeId,data} = props ?? {};

          return  patchApiCompaniesCurrentEmployeesEmployeeIdActionModules(employeeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentEmployeesEmployeeIdActionModulesMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdActionModules>>>
    export type PatchApiCompaniesCurrentEmployeesEmployeeIdActionModulesMutationBody = number[] | undefined
    export type PatchApiCompaniesCurrentEmployeesEmployeeIdActionModulesMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentEmployeesEmployeeIdActionModules = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdActionModules>>, TError,{employeeId: string;data?: number[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdActionModules>>,
        TError,
        {employeeId: string;data?: number[]},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentEmployeesEmployeeIdActionModulesMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentEmployeesEmployeeIdServiceModules = (
    employeeId: string,
 signal?: AbortSignal
) => {


      return axiosInstance<number[]>(
      {url: `/api/companies/current/employees/${employeeId}/serviceModules`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentEmployeesEmployeeIdServiceModulesQueryKey = (employeeId: string,) => {
    return [
    `/api/companies/current/employees/${employeeId}/serviceModules`
    ] as const;
    }


export const getGetApiCompaniesCurrentEmployeesEmployeeIdServiceModulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError = ErrorResponse>(employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentEmployeesEmployeeIdServiceModulesQueryKey(employeeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>> = ({ signal }) => getApiCompaniesCurrentEmployeesEmployeeIdServiceModules(employeeId, signal);





   return  { queryKey, queryFn, enabled: employeeId !== null && employeeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentEmployeesEmployeeIdServiceModulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>>
export type GetApiCompaniesCurrentEmployeesEmployeeIdServiceModulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentEmployeesEmployeeIdServiceModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError = ErrorResponse>(
 employeeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeIdServiceModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentEmployeesEmployeeIdServiceModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentEmployeesEmployeeIdServiceModules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError = ErrorResponse>(
 employeeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentEmployeesEmployeeIdServiceModulesQueryOptions(employeeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules = (
    employeeId: string,
    patchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesBody?: number[],
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/employees/${employeeId}/serviceModules`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesBody, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError,{employeeId: string;data?: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError,{employeeId: string;data?: number[]}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, {employeeId: string;data?: number[]}> = (props) => {
          const {employeeId,data} = props ?? {};

          return  patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules(employeeId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>>
    export type PatchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesMutationBody = number[] | undefined
    export type PatchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentEmployeesEmployeeIdServiceModules = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>, TError,{employeeId: string;data?: number[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentEmployeesEmployeeIdServiceModules>>,
        TError,
        {employeeId: string;data?: number[]},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentEmployeesEmployeeIdServiceModulesMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation = (
    actionModuleId: number,
    actionModuleInstanceIncentivationRequest?: ActionModuleInstanceIncentivationRequest[],
 signal?: AbortSignal
) => {


      return axiosInstance<CompleteInstanceValidationResultModel>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/incentivation`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: actionModuleInstanceIncentivationRequest, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentActionmodulesActionModuleIdIncentivationMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation>>, TError,{actionModuleId: number;data?: ActionModuleInstanceIncentivationRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation>>, TError,{actionModuleId: number;data?: ActionModuleInstanceIncentivationRequest[]}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation>>, {actionModuleId: number;data?: ActionModuleInstanceIncentivationRequest[]}> = (props) => {
          const {actionModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation(actionModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdIncentivationMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation>>>
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdIncentivationMutationBody = ActionModuleInstanceIncentivationRequest[] | undefined
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdIncentivationMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation>>, TError,{actionModuleId: number;data?: ActionModuleInstanceIncentivationRequest[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIncentivation>>,
        TError,
        {actionModuleId: number;data?: ActionModuleInstanceIncentivationRequest[]},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentActionmodulesActionModuleIdIncentivationMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId = (
    actionModuleId: number,
    employeeId: string,
    actionModuleInstanceId: number,
    binaryRewardCalculationInformationScoreRewardCalculationInformationManualInputRewardCalculationInformation?: BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleCompletionResult>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/employees/${employeeId}/instances/${actionModuleInstanceId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: binaryRewardCalculationInformationScoreRewardCalculationInformationManualInputRewardCalculationInformation, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId>>, TError,{actionModuleId: number;employeeId: string;actionModuleInstanceId: number;data?: BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId>>, TError,{actionModuleId: number;employeeId: string;actionModuleInstanceId: number;data?: BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId>>, {actionModuleId: number;employeeId: string;actionModuleInstanceId: number;data?: BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation}> = (props) => {
          const {actionModuleId,employeeId,actionModuleInstanceId,data} = props ?? {};

          return  patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId(actionModuleId,employeeId,actionModuleInstanceId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId>>>
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceIdMutationBody = BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation | undefined
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId>>, TError,{actionModuleId: number;employeeId: string;actionModuleInstanceId: number;data?: BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceId>>,
        TError,
        {actionModuleId: number;employeeId: string;actionModuleInstanceId: number;data?: BinaryRewardCalculationInformation | ScoreRewardCalculationInformation | ManualInputRewardCalculationInformation},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesActionModuleInstanceIdMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances = (
    actionModuleId: number,
    employeeId: string,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleInstanceModel[]>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/employees/${employeeId}/instances`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesQueryKey = (actionModuleId: number,
    employeeId: string,
    params?: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams,) => {
    return [
    `/api/companies/current/actionmodules/${actionModuleId}/employees/${employeeId}/instances`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError = ErrorResponse>(actionModuleId: number,
    employeeId: string,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesQueryKey(actionModuleId,employeeId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>> = ({ signal }) => getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances(actionModuleId,employeeId,params, signal);





   return  { queryKey, queryFn, enabled: actionModuleId !== null && actionModuleId !== undefined && employeeId !== null && employeeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>>
export type GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError = ErrorResponse>(
 actionModuleId: number,
    employeeId: string,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError = ErrorResponse>(
 actionModuleId: number,
    employeeId: string,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError = ErrorResponse>(
 actionModuleId: number,
    employeeId: string,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError = ErrorResponse>(
 actionModuleId: number,
    employeeId: string,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstances>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesEmployeeIdInstancesQueryOptions(actionModuleId,employeeId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook = (
    actionModuleId: number,
    actionModuleInstanceId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/instances/${actionModuleInstanceId}/transactions/book`, method: 'POST', signal
    },
      );
    }




export const getPostApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBookMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook>>, TError,{actionModuleId: number;actionModuleInstanceId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook>>, TError,{actionModuleId: number;actionModuleInstanceId: number}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook>>, {actionModuleId: number;actionModuleInstanceId: number}> = (props) => {
          const {actionModuleId,actionModuleInstanceId} = props ?? {};

          return  postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook(actionModuleId,actionModuleInstanceId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBookMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook>>>

    export type PostApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBookMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook>>, TError,{actionModuleId: number;actionModuleInstanceId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBook>>,
        TError,
        {actionModuleId: number;actionModuleInstanceId: number},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentActionmodulesActionModuleIdInstancesActionModuleInstanceIdTransactionsBookMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentActionmodules = (

 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse[]>(
      {url: `/api/companies/current/actionmodules`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentActionmodulesQueryKey = () => {
    return [
    `/api/companies/current/actionmodules`
    ] as const;
    }


export const getGetApiCompaniesCurrentActionmodulesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError = ErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentActionmodulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>> = ({ signal }) => getApiCompaniesCurrentActionmodules(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentActionmodulesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>>
export type GetApiCompaniesCurrentActionmodulesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentActionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError = ErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentActionmodules<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError = ErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodules>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentActionmodulesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postApiCompaniesCurrentActionmodules = (
    createActionModuleRequest?: NonReadonly<CreateActionModuleRequest>,
    params?: PostApiCompaniesCurrentActionmodulesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/companies/current/actionmodules`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActionModuleRequest,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentActionmodulesMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodules>>, TError,{data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiCompaniesCurrentActionmodulesParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodules>>, TError,{data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiCompaniesCurrentActionmodulesParams}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentActionmodules'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodules>>, {data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiCompaniesCurrentActionmodulesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postApiCompaniesCurrentActionmodules(data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentActionmodulesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodules>>>
    export type PostApiCompaniesCurrentActionmodulesMutationBody = NonReadonly<CreateActionModuleRequest> | undefined
    export type PostApiCompaniesCurrentActionmodulesMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentActionmodules = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodules>>, TError,{data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiCompaniesCurrentActionmodulesParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodules>>,
        TError,
        {data?: NonReadonly<CreateActionModuleRequest>;params?: PostApiCompaniesCurrentActionmodulesParams},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentActionmodulesMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentActionmodulesFiltered = (
    params?: GetApiCompaniesCurrentActionmodulesFilteredParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse[]>(
      {url: `/api/companies/current/actionmodules/filtered`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentActionmodulesFilteredQueryKey = (params?: GetApiCompaniesCurrentActionmodulesFilteredParams,) => {
    return [
    `/api/companies/current/actionmodules/filtered`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentActionmodulesFilteredQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError = ErrorResponse>(params?: GetApiCompaniesCurrentActionmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentActionmodulesFilteredQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>> = ({ signal }) => getApiCompaniesCurrentActionmodulesFiltered(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentActionmodulesFilteredQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>>
export type GetApiCompaniesCurrentActionmodulesFilteredQueryError = ErrorResponse


export function useGetApiCompaniesCurrentActionmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError = ErrorResponse>(
 params: undefined |  GetApiCompaniesCurrentActionmodulesFilteredParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentActionmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentActionmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentActionmodulesFiltered<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError = ErrorResponse>(
 params?: GetApiCompaniesCurrentActionmodulesFilteredParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesFiltered>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentActionmodulesFilteredQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentActionmodulesActionModuleId = (
    actionModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentActionmodulesActionModuleIdQueryKey = (actionModuleId: number,) => {
    return [
    `/api/companies/current/actionmodules/${actionModuleId}`
    ] as const;
    }


export const getGetApiCompaniesCurrentActionmodulesActionModuleIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError = ErrorResponse>(actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentActionmodulesActionModuleIdQueryKey(actionModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>> = ({ signal }) => getApiCompaniesCurrentActionmodulesActionModuleId(actionModuleId, signal);





   return  { queryKey, queryFn, enabled: actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentActionmodulesActionModuleIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>>
export type GetApiCompaniesCurrentActionmodulesActionModuleIdQueryError = ErrorResponse


export function useGetApiCompaniesCurrentActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentActionmodulesActionModuleId<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError = ErrorResponse>(
 actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentActionmodulesActionModuleIdQueryOptions(actionModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentActionmodulesActionModuleId = (
    actionModuleId: number,
    updateActionModuleRequest?: NonReadonly<UpdateActionModuleRequest>,
    params?: PatchApiCompaniesCurrentActionmodulesActionModuleIdParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateActionModuleRequest,
        params, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentActionmodulesActionModuleIdMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleId>>, TError,{actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiCompaniesCurrentActionmodulesActionModuleIdParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleId>>, TError,{actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiCompaniesCurrentActionmodulesActionModuleIdParams}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentActionmodulesActionModuleId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleId>>, {actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiCompaniesCurrentActionmodulesActionModuleIdParams}> = (props) => {
          const {actionModuleId,data,params} = props ?? {};

          return  patchApiCompaniesCurrentActionmodulesActionModuleId(actionModuleId,data,params,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleId>>>
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdMutationBody = NonReadonly<UpdateActionModuleRequest> | undefined
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentActionmodulesActionModuleId = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleId>>, TError,{actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiCompaniesCurrentActionmodulesActionModuleIdParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleId>>,
        TError,
        {actionModuleId: number;data?: NonReadonly<UpdateActionModuleRequest>;params?: PatchApiCompaniesCurrentActionmodulesActionModuleIdParams},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentActionmodulesActionModuleIdMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType = (
    actionModuleId: number,
    updateActionModuleRewardCalculationWalletTypeRequest?: UpdateActionModuleRewardCalculationWalletTypeRequest,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleResponse>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/reward-calculation/wallet-type`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateActionModuleRewardCalculationWalletTypeRequest, signal
    },
      );
    }




export const getPutApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletTypeMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType>>, TError,{actionModuleId: number;data?: UpdateActionModuleRewardCalculationWalletTypeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType>>, TError,{actionModuleId: number;data?: UpdateActionModuleRewardCalculationWalletTypeRequest}, TContext> => {

const mutationKey = ['putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType>>, {actionModuleId: number;data?: UpdateActionModuleRewardCalculationWalletTypeRequest}> = (props) => {
          const {actionModuleId,data} = props ?? {};

          return  putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType(actionModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletTypeMutationResult = NonNullable<Awaited<ReturnType<typeof putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType>>>
    export type PutApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletTypeMutationBody = UpdateActionModuleRewardCalculationWalletTypeRequest | undefined
    export type PutApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletTypeMutationError = ErrorResponse

    /**
 * @deprecated
 */
export const usePutApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType>>, TError,{actionModuleId: number;data?: UpdateActionModuleRewardCalculationWalletTypeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletType>>,
        TError,
        {actionModuleId: number;data?: UpdateActionModuleRewardCalculationWalletTypeRequest},
        TContext
      > => {
      return useMutation(getPutApiCompaniesCurrentActionmodulesActionModuleIdRewardCalculationWalletTypeMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentActionmodulesActionModuleIdImport = (
    actionModuleId: number,
    params: PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams,
    importActionModuleScoresRequest?: ImportActionModuleScoresRequest[],
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importActionModuleScoresRequest,
        params, signal
    },
      );
    }




export const getPostApiCompaniesCurrentActionmodulesActionModuleIdImportMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdImport>>, TError,{actionModuleId: number;params: PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams;data?: ImportActionModuleScoresRequest[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdImport>>, TError,{actionModuleId: number;params: PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams;data?: ImportActionModuleScoresRequest[]}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentActionmodulesActionModuleIdImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdImport>>, {actionModuleId: number;params: PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams;data?: ImportActionModuleScoresRequest[]}> = (props) => {
          const {actionModuleId,params,data} = props ?? {};

          return  postApiCompaniesCurrentActionmodulesActionModuleIdImport(actionModuleId,params,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentActionmodulesActionModuleIdImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdImport>>>
    export type PostApiCompaniesCurrentActionmodulesActionModuleIdImportMutationBody = ImportActionModuleScoresRequest[] | undefined
    export type PostApiCompaniesCurrentActionmodulesActionModuleIdImportMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentActionmodulesActionModuleIdImport = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdImport>>, TError,{actionModuleId: number;params: PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams;data?: ImportActionModuleScoresRequest[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdImport>>,
        TError,
        {actionModuleId: number;params: PostApiCompaniesCurrentActionmodulesActionModuleIdImportParams;data?: ImportActionModuleScoresRequest[]},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentActionmodulesActionModuleIdImportMutationOptions(options), queryClient);
    }
    export const getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter = (
    actionModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleIncentivationPageFiltersResponse>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/employees/filter`, method: 'GET', signal
    },
      );
    }




export const getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilterQueryKey = (actionModuleId: number,) => {
    return [
    `/api/companies/current/actionmodules/${actionModuleId}/employees/filter`
    ] as const;
    }


export const getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilterQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError = ErrorResponse>(actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilterQueryKey(actionModuleId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>> = ({ signal }) => getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter(actionModuleId, signal);





   return  { queryKey, queryFn, enabled: actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilterQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>>
export type GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilterQueryError = ErrorResponse


export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError = ErrorResponse>(
 actionModuleId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError = ErrorResponse>(
 actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError = ErrorResponse>(
 actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError = ErrorResponse>(
 actionModuleId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilter>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesFilterQueryOptions(actionModuleId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApiCompaniesCurrentActionmodulesActionModuleIdEmployees = (
    actionModuleId: number,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams,
 signal?: AbortSignal
) => {


      return axiosInstance<ActionModuleEmployeeResponsePaginatedResponse>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/employees`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesQueryKey = (actionModuleId: number,
    params?: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams,) => {
    return [
    `/api/companies/current/actionmodules/${actionModuleId}/employees`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError = ErrorResponse>(actionModuleId: number,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesQueryKey(actionModuleId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>> = ({ signal }) => getApiCompaniesCurrentActionmodulesActionModuleIdEmployees(actionModuleId,params, signal);





   return  { queryKey, queryFn, enabled: actionModuleId !== null && actionModuleId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>>
export type GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesQueryError = ErrorResponse


export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError = ErrorResponse>(
 actionModuleId: number,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError = ErrorResponse>(
 actionModuleId: number,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError = ErrorResponse>(
 actionModuleId: number,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiCompaniesCurrentActionmodulesActionModuleIdEmployees<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError = ErrorResponse>(
 actionModuleId: number,
    params: GetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentActionmodulesActionModuleIdEmployees>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentActionmodulesActionModuleIdEmployeesQueryOptions(actionModuleId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchApiCompaniesCurrentActionmodulesActionModuleIdIcon = (
    actionModuleId: number,
    patchApiCompaniesCurrentActionmodulesActionModuleIdIconBody?: PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody,
 signal?: AbortSignal
) => {

      const formData = new FormData();
if(patchApiCompaniesCurrentActionmodulesActionModuleIdIconBody?.File !== undefined) {
 formData.append(`File`, patchApiCompaniesCurrentActionmodulesActionModuleIdIconBody.File);
 }

      return axiosInstance<void>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/icon`, method: 'PATCH',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentActionmodulesActionModuleIdIconMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIcon>>, TError,{actionModuleId: number;data?: PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIcon>>, TError,{actionModuleId: number;data?: PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentActionmodulesActionModuleIdIcon'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIcon>>, {actionModuleId: number;data?: PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody}> = (props) => {
          const {actionModuleId,data} = props ?? {};

          return  patchApiCompaniesCurrentActionmodulesActionModuleIdIcon(actionModuleId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdIconMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIcon>>>
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdIconMutationBody = PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody | undefined
    export type PatchApiCompaniesCurrentActionmodulesActionModuleIdIconMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentActionmodulesActionModuleIdIcon = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIcon>>, TError,{actionModuleId: number;data?: PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesActionModuleIdIcon>>,
        TError,
        {actionModuleId: number;data?: PatchApiCompaniesCurrentActionmodulesActionModuleIdIconBody},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentActionmodulesActionModuleIdIconMutationOptions(options), queryClient);
    }
    export const patchApiCompaniesCurrentActionmodulesOrder = (
    patchApiCompaniesCurrentActionmodulesOrderBody?: number[],
 signal?: AbortSignal
) => {


      return axiosInstance<number[]>(
      {url: `/api/companies/current/actionmodules/order`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiCompaniesCurrentActionmodulesOrderBody, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentActionmodulesOrderMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesOrder>>, TError,{data?: number[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesOrder>>, TError,{data?: number[]}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentActionmodulesOrder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesOrder>>, {data?: number[]}> = (props) => {
          const {data} = props ?? {};

          return  patchApiCompaniesCurrentActionmodulesOrder(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentActionmodulesOrderMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesOrder>>>
    export type PatchApiCompaniesCurrentActionmodulesOrderMutationBody = number[] | undefined
    export type PatchApiCompaniesCurrentActionmodulesOrderMutationError = ErrorResponse

    export const usePatchApiCompaniesCurrentActionmodulesOrder = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesOrder>>, TError,{data?: number[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentActionmodulesOrder>>,
        TError,
        {data?: number[]},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentActionmodulesOrderMutationOptions(options), queryClient);
    }
    export const postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook = (
    actionModuleId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<void>(
      {url: `/api/companies/current/actionmodules/${actionModuleId}/transactions/book`, method: 'POST', signal
    },
      );
    }




export const getPostApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBookMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook>>, TError,{actionModuleId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook>>, TError,{actionModuleId: number}, TContext> => {

const mutationKey = ['postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook>>, {actionModuleId: number}> = (props) => {
          const {actionModuleId} = props ?? {};

          return  postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook(actionModuleId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBookMutationResult = NonNullable<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook>>>

    export type PostApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBookMutationError = ErrorResponse

    export const usePostApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook>>, TError,{actionModuleId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBook>>,
        TError,
        {actionModuleId: number},
        TContext
      > => {
      return useMutation(getPostApiCompaniesCurrentActionmodulesActionModuleIdTransactionsBookMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const getApiCompaniesCurrentDocumentmanagement = (
    params: GetApiCompaniesCurrentDocumentmanagementParams,
 signal?: AbortSignal
) => {


      return axiosInstance<unknown>(
      {url: `/api/companies/current/documentmanagement`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiCompaniesCurrentDocumentmanagementQueryKey = (params?: GetApiCompaniesCurrentDocumentmanagementParams,) => {
    return [
    `/api/companies/current/documentmanagement`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiCompaniesCurrentDocumentmanagementQueryOptions = <TData = Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError = ProblemDetails>(params: GetApiCompaniesCurrentDocumentmanagementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiCompaniesCurrentDocumentmanagementQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>> = ({ signal }) => getApiCompaniesCurrentDocumentmanagement(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiCompaniesCurrentDocumentmanagementQueryResult = NonNullable<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>>
export type GetApiCompaniesCurrentDocumentmanagementQueryError = ProblemDetails


export function useGetApiCompaniesCurrentDocumentmanagement<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError = ProblemDetails>(
 params: GetApiCompaniesCurrentDocumentmanagementParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentDocumentmanagement<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError = ProblemDetails>(
 params: GetApiCompaniesCurrentDocumentmanagementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>,
          TError,
          Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiCompaniesCurrentDocumentmanagement<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError = ProblemDetails>(
 params: GetApiCompaniesCurrentDocumentmanagementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @deprecated
 */

export function useGetApiCompaniesCurrentDocumentmanagement<TData = Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError = ProblemDetails>(
 params: GetApiCompaniesCurrentDocumentmanagementParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiCompaniesCurrentDocumentmanagement>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiCompaniesCurrentDocumentmanagementQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @deprecated
 */
export const patchApiCompaniesCurrentDocumentmanagementDocumentManagementId = (
    documentManagementId: number,
    documentManagementRequestBase?: DocumentManagementRequestBase,
 signal?: AbortSignal
) => {


      return axiosInstance<unknown>(
      {url: `/api/companies/current/documentmanagement/${documentManagementId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: documentManagementRequestBase, signal
    },
      );
    }




export const getPatchApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, TError,{documentManagementId: number;data?: DocumentManagementRequestBase}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, TError,{documentManagementId: number;data?: DocumentManagementRequestBase}, TContext> => {

const mutationKey = ['patchApiCompaniesCurrentDocumentmanagementDocumentManagementId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, {documentManagementId: number;data?: DocumentManagementRequestBase}> = (props) => {
          const {documentManagementId,data} = props ?? {};

          return  patchApiCompaniesCurrentDocumentmanagementDocumentManagementId(documentManagementId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiCompaniesCurrentDocumentmanagementDocumentManagementId>>>
    export type PatchApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationBody = DocumentManagementRequestBase | undefined
    export type PatchApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationError = ProblemDetails

    /**
 * @deprecated
 */
export const usePatchApiCompaniesCurrentDocumentmanagementDocumentManagementId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, TError,{documentManagementId: number;data?: DocumentManagementRequestBase}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApiCompaniesCurrentDocumentmanagementDocumentManagementId>>,
        TError,
        {documentManagementId: number;data?: DocumentManagementRequestBase},
        TContext
      > => {
      return useMutation(getPatchApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationOptions(options), queryClient);
    }
    /**
 * @deprecated
 */
export const deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId = (
    documentManagementId: number,
 signal?: AbortSignal
) => {


      return axiosInstance<unknown>(
      {url: `/api/companies/current/documentmanagement/${documentManagementId}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationOptions = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, TError,{documentManagementId: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, TError,{documentManagementId: number}, TContext> => {

const mutationKey = ['deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, {documentManagementId: number}> = (props) => {
          const {documentManagementId} = props ?? {};

          return  deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId(documentManagementId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId>>>

    export type DeleteApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationError = ProblemDetails

    /**
 * @deprecated
 */
export const useDeleteApiCompaniesCurrentDocumentmanagementDocumentManagementId = <TError = ProblemDetails,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId>>, TError,{documentManagementId: number}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiCompaniesCurrentDocumentmanagementDocumentManagementId>>,
        TError,
        {documentManagementId: number},
        TContext
      > => {
      return useMutation(getDeleteApiCompaniesCurrentDocumentmanagementDocumentManagementIdMutationOptions(options), queryClient);
    }
